import { Fragment, Teleport, TransitionGroup, computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createTextVNode, createVNode, defineComponent, inject, markRaw, mergeProps, nextTick, normalizeClass, normalizeStyle, onBeforeUnmount, onMounted, onUnmounted, openBlock, provide, reactive, ref, renderList, renderSlot, resolveComponent, resolveDirective, resolveDynamicComponent, toDisplayString, toValue, unref, useId, useSlots, vModelSelect, vModelText, vShow, watch, withCtx, withDirectives, withKeys, withModifiers } from "vue";
import * as uuid from "uuid";
import { AttributionControl, LngLat, Map as Map$1 } from "maplibre-gl";
//#region \0@oxc-project+runtime@0.138.0/helpers/esm/typeof.js
function _typeof(o) {
	"@babel/helpers - typeof";
	return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
		return typeof o;
	} : function(o) {
		return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	}, _typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.138.0/helpers/esm/toPrimitive.js
function toPrimitive(t, r) {
	if ("object" != _typeof(t) || !t) return t;
	var e = t[Symbol.toPrimitive];
	if (void 0 !== e) {
		var i = e.call(t, r || "default");
		if ("object" != _typeof(i)) return i;
		throw new TypeError("@@toPrimitive must return a primitive value.");
	}
	return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.138.0/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
	var i = toPrimitive(t, "string");
	return "symbol" == _typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.138.0/helpers/esm/defineProperty.js
function _defineProperty(e, r, t) {
	return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
		value: t,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[r] = t, e;
}
//#endregion
//#region src/util/Vector2.ts
var Vector2 = class Vector2 {
	constructor(x = 0, y = 0) {
		_defineProperty(this, "values", [0, 0]);
		this.values[0] = x;
		this.values[1] = y;
	}
	get x() {
		return this.values[0];
	}
	set x(newval) {
		this.values[0] = newval;
	}
	get y() {
		return this.values[1];
	}
	set y(newval) {
		this.values[1] = newval;
	}
	add(other) {
		return new Vector2(this.x + other.x, this.y + other.y);
	}
	clone() {
		return new Vector2(this.x, this.y);
	}
	dist(v2) {
		return this.sub(v2).len();
	}
	equals(other) {
		return this.x == other.x && this.y == other.y;
	}
	len() {
		return Math.sqrt(this.x * this.x + this.y * this.y);
	}
	scalarMult(value) {
		return new Vector2(this.x * value, this.y * value);
	}
	sub(other) {
		return new Vector2(this.x - other.x, this.y - other.y);
	}
	toString() {
		return "(" + this.x + ", " + this.y + ")";
	}
};
function vector2Min(v1, v2) {
	return new Vector2(Math.min(v1.x, v2.x), Math.min(v1.y, v2.y));
}
function vector2Max(v1, v2) {
	return new Vector2(Math.max(v1.x, v2.x), Math.max(v1.y, v2.y));
}
//#endregion
//#region src/components/multiChart/MultiChartState.ts
var MultiChartState = class {
	constructor() {
		_defineProperty(this, "padding", [
			0,
			0,
			0,
			0
		]);
		_defineProperty(this, "chartAreaPos", new Vector2(this.padding[3], this.padding[0]));
		_defineProperty(this, "chartAreaSize", new Vector2());
		_defineProperty(this, "autoScaleX", false);
		_defineProperty(this, "autoScaleY", false);
		_defineProperty(this, "bottomLeftWorld", new Vector2());
		_defineProperty(this, "scale", new Vector2(1, 1));
		_defineProperty(this, "displayMin", new Vector2(Number.MAX_VALUE, Number.MAX_VALUE));
		_defineProperty(this, "displayMax", new Vector2(Number.MIN_VALUE, Number.MIN_VALUE));
		_defineProperty(this, "mousePos", new Vector2(0, 0));
		_defineProperty(this, "extent", [
			null,
			null,
			null,
			null
		]);
		_defineProperty(
			this,
			/** Incremented each time chart data changes; used by child components to trigger re-renders. */
			"dataChangeVersion",
			0
		);
	}
	getActualExtent() {
		const extent = [...this.extent];
		extent[0] = extent[0] ?? this.displayMin.x;
		extent[1] = extent[1] ?? this.displayMin.y;
		extent[2] = extent[2] ?? this.displayMax.x;
		extent[3] = extent[3] ?? this.displayMax.y;
		return extent;
	}
	updatePosAndScale() {
		const e = this.getActualExtent();
		const extentMin = new Vector2(e[0], e[1]);
		const extentMax = new Vector2(e[2], e[3]);
		this.bottomLeftWorld = extentMin;
		const extentRange = extentMax.sub(extentMin);
		this.scale = new Vector2(this.chartAreaSize.x / extentRange.x, this.chartAreaSize.y / extentRange.y);
	}
	onChartDataChange() {
		this.displayMin = new Vector2(Number.MAX_VALUE, Number.MAX_VALUE);
		this.displayMax = new Vector2(Number.MIN_VALUE, Number.MIN_VALUE);
		this.dataChangeVersion++;
	}
	setBottomLeftWorld(v) {
		const e = this.getActualExtent();
		const extentRange = new Vector2(e[2] - e[0], e[3] - e[1]);
		this.extent = [
			v.x,
			v.y,
			v.x + extentRange.x,
			v.y + extentRange.y
		];
		this.updatePosAndScale();
	}
	setExtent(extent) {
		if (!Array.isArray(extent)) return;
		if (!extent.some((v) => v !== null && v !== void 0)) return;
		const newExtent = [...this.extent];
		for (let i = 0; i < 4; i++) {
			const v = extent[i];
			if (v === null || v === void 0) continue;
			const n = Number(v);
			if (!Number.isFinite(n)) continue;
			newExtent[i] = n;
		}
		this.extent = newExtent;
		this.updatePosAndScale();
	}
	updateDisplayMinMax(min, max) {
		const dmin = vector2Min(min, this.displayMin);
		const dmax = vector2Max(max, this.displayMax);
		if (dmin.equals(this.displayMin) && dmax.equals(this.displayMax)) return;
		this.displayMin = dmin;
		this.displayMax = dmax;
		this.updatePosAndScale();
	}
	s2w(v) {
		return new Vector2(v.x / this.scale.x + this.bottomLeftWorld.x, (this.chartAreaSize.y - v.y) / this.scale.y + this.bottomLeftWorld.y);
	}
	s2wx(pixels) {
		return pixels / this.scale.x + this.bottomLeftWorld.x;
	}
	s2wy(pixels) {
		return (this.chartAreaSize.y - pixels) / this.scale.y + this.bottomLeftWorld.y;
	}
	w2sx(value) {
		return (value - this.bottomLeftWorld.x) * this.scale.x;
	}
	w2sy(value) {
		return this.chartAreaSize.y - (value - this.bottomLeftWorld.y) * this.scale.y;
	}
};
//#endregion
//#region src/components/multiChart/injectionKeys.ts
var chartCanvasStateKey = Symbol();
//#endregion
//#region src/composables/useEventListener.ts
function useEventListener(target, event, callback, options = void 0) {
	onMounted(() => {
		const elem = unref(target);
		if (elem != null) elem.addEventListener(event, callback, options);
	});
	onBeforeUnmount(() => {
		const elem = unref(target);
		if (elem != null) elem.removeEventListener(event, callback, options);
	});
}
//#endregion
//#region src/util/touchUtil.ts
function getTouchPosRelativeToElement(element, touches) {
	const result = Array();
	const el = unref(element);
	if (el == null) return result;
	const rect = el.getBoundingClientRect();
	for (let ii = 0; ii < touches.length; ii++) {
		const touch = touches.item(ii);
		if (touch == null) continue;
		result.push({
			x: touch.clientX - rect.left,
			y: touch.clientY - rect.top
		});
	}
	return result;
}
//#endregion
//#region src/composables/useTouchesOnElement.ts
function useTouchesOnElement(target, minTouchPointsToPrevenDefault) {
	const touches = ref([]);
	function onTouchMove(evt) {
		if (evt.touches.length >= minTouchPointsToPrevenDefault) evt.preventDefault();
		touches.value = getTouchPosRelativeToElement(target, evt.touches);
	}
	function onTouchEnd(evt) {
		touches.value = [];
	}
	function onTouchStart(evt) {
		if (evt.touches.length >= minTouchPointsToPrevenDefault) evt.preventDefault();
		touches.value = getTouchPosRelativeToElement(target, evt.touches);
	}
	useEventListener(target, "touchmove", onTouchMove);
	useEventListener(target, "touchstart", onTouchStart);
	useEventListener(target, "touchend", onTouchEnd);
	return touches;
}
//#endregion
//#region src/composables/usePressedKeys.ts
function usePressedKeys(target) {
	const pressed_keys = ref({});
	function onKeyDown(evt) {
		pressed_keys.value[evt.code] = true;
	}
	function onKeyUp(evt) {
		delete pressed_keys.value[evt.code];
	}
	useEventListener(target, "keydown", onKeyDown);
	useEventListener(target, "keyup", onKeyUp);
	return pressed_keys;
}
//#endregion
//#region src/composables/useOnElementResize.ts
function useOnElementResize(target, callback) {
	const observer = new ResizeObserver((entries) => callback(entries[0]));
	onMounted(() => {
		const el = unref(target);
		if (el != null) observer.observe(el);
	});
	onUnmounted(() => {
		observer.disconnect();
	});
}
//#endregion
//#region src/composables/useElementSize.ts
function useElementSize(target) {
	const size = ref(new Vector2());
	const onResize = () => {
		const el = unref(target);
		if (!el) return;
		const rect = el.getBoundingClientRect();
		size.value = new Vector2(rect.width, rect.height);
	};
	useOnElementResize(target, onResize);
	return size;
}
//#endregion
//#region src/components/multiChart/MultiChart.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$32 = { class: "v-multi-chart" };
var _hoisted_2$24 = ["id"];
var _hoisted_3$19 = ["width", "height"];
var _hoisted_4$17 = ["width", "height"];
var _hoisted_5$6 = [
	"x",
	"y",
	"width",
	"height"
];
var _hoisted_6$3 = ["transform"];
var cfg_zoomSpeed = 1.1;
//#endregion
//#region src/components/multiChart/MultiChart.vue
var MultiChart_default = /* @__PURE__ */ defineComponent({
	__name: "MultiChart",
	props: {
		allowPanX: {
			type: Boolean,
			default: false
		},
		allowPanY: {
			type: Boolean,
			default: false
		},
		allowZoomX: {
			type: Boolean,
			default: false
		},
		allowZoomY: {
			type: Boolean,
			default: false
		},
		debug: {
			type: Boolean,
			default: false
		},
		extentIn: { default: () => [
			null,
			null,
			null,
			null
		] },
		padding: { default: () => [
			10,
			15,
			30,
			60
		] },
		resetExtentTrigger: { type: Boolean }
	},
	emits: ["update:extent-out", "update:minmax-out"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const svgStyle = ref({});
		const clipPathId = ref("id" + uuid.v4());
		const canvas = ref(new MultiChartState());
		const svg = ref(null);
		useEventListener(document, "mouseup", onDocumentMouseUp);
		useEventListener(document, "mousemove", onDocumentMouseMove);
		useEventListener(svg, "wheel", onWheel);
		const touches = useTouchesOnElement(svg, 2);
		const pressedKeys = usePressedKeys(document);
		const viewBoxSize = useElementSize(svg);
		provide(chartCanvasStateKey, canvas);
		let touchCenterPosScreen_at_pan_start = new Vector2();
		let scale_at_pan_start = new Vector2();
		let pointersDistance_at_pan_start = new Vector2();
		let mousePanActive = false;
		function getMousePosOnChartArea(evt) {
			return new Vector2(evt.offsetX, evt.offsetY).sub(canvas.value.chartAreaPos);
		}
		function onDocumentMouseMove(evt) {
			const mousePos = new Vector2(evt.clientX, evt.clientY);
			if (!mousePanActive) return;
			pan(mousePos);
		}
		function onDocumentMouseUp(evt) {
			mousePanActive = false;
			document.body.style.userSelect = "auto";
			svgStyle.value = {};
			emit("update:extent-out", canvas.value.getActualExtent());
		}
		function onMouseDown(evt) {
			const pos = new Vector2(evt.clientX, evt.clientY);
			document.body.style.userSelect = "none";
			mousePanActive = true;
			touchCenterPosScreen_at_pan_start = pos;
			if (props.allowPanX || props.allowPanY) svgStyle.value = { "cursor": "grabbing" };
		}
		function onWheel(evt) {
			if (!pressedKeys.value["AltLeft"]) return;
			evt.preventDefault();
			if (!props.allowZoomX || !props.allowPanX) return;
			const mousePosOnChartArea = getMousePosOnChartArea(evt);
			const scale = canvas.value.scale.clone();
			if (evt.deltaY < 0) scale.x *= cfg_zoomSpeed;
			else if (evt.deltaY > 0) scale.x /= cfg_zoomSpeed;
			zoom(scale.x, scale.y, mousePosOnChartArea);
			emit("update:extent-out", canvas.value.getActualExtent());
		}
		function pan(pan_pos_screen) {
			const pan_pos_world = canvas.value.s2w(pan_pos_screen);
			const start_pos_world = canvas.value.s2w(touchCenterPosScreen_at_pan_start);
			const diff = pan_pos_world.sub(start_pos_world);
			if (!props.allowPanX) diff.x = 0;
			if (!props.allowPanY) diff.y = 0;
			if (diff.x == 0 && diff.y == 0) return;
			canvas.value.setBottomLeftWorld(canvas.value.bottomLeftWorld.sub(diff));
			touchCenterPosScreen_at_pan_start = pan_pos_screen;
		}
		function touchZoomStart(touchPos1, touchPos2) {
			scale_at_pan_start = canvas.value.scale.clone();
			pointersDistance_at_pan_start = touchPos1.sub(touchPos2);
			touchCenterPosScreen_at_pan_start = touchPos1.add(touchPos2).scalarMult(.5);
		}
		function touchZoomMove(touchPos1, touchPos2) {
			const pointerDistanceNow = touchPos1.sub(touchPos2);
			const d = new Vector2(pointerDistanceNow.x / pointersDistance_at_pan_start.x, pointerDistanceNow.y / pointersDistance_at_pan_start.y);
			const center = touchPos1.add(touchPos2).scalarMult(.5);
			pan(center);
			const scale = canvas.value.scale.clone();
			if (Math.abs(pointersDistance_at_pan_start.x) > Math.abs(pointersDistance_at_pan_start.y)) {
				if (props.allowZoomX) scale.x = scale_at_pan_start.x * d.x;
			} else if (props.allowZoomY) scale.y = scale_at_pan_start.y * d.y;
			zoom(scale.x, scale.y, center);
			emit("update:extent-out", canvas.value.getActualExtent());
		}
		function updateChartAreaPosAndSize() {
			if (svg.value == null) return;
			const sx = viewBoxSize.value.x;
			const sy = viewBoxSize.value.y;
			if (sx == 0 || sy == 0) return;
			const paddingTop = canvas.value.padding[0];
			const paddingRight = canvas.value.padding[1];
			const paddingBottom = canvas.value.padding[2];
			const paddingLeft = canvas.value.padding[3];
			canvas.value.chartAreaPos = new Vector2(paddingLeft, paddingTop);
			canvas.value.chartAreaSize = new Vector2(sx - paddingLeft - paddingRight, sy - paddingTop - paddingBottom);
			canvas.value.updatePosAndScale();
		}
		function zoom(fx, fy, center) {
			const center_world_before_scale = canvas.value.s2w(center);
			const extent = [...canvas.value.getActualExtent()];
			extent[2] = extent[0] + canvas.value.chartAreaSize.x / fx;
			extent[3] = extent[1] + canvas.value.chartAreaSize.y / fy;
			canvas.value.setExtent(extent);
			const diff = canvas.value.s2w(center).sub(center_world_before_scale);
			canvas.value.setBottomLeftWorld(canvas.value.bottomLeftWorld.sub(diff));
		}
		watch(() => props.extentIn, (newVal, oldVal) => {
			canvas.value.setExtent(props.extentIn);
		}, {
			immediate: true,
			deep: true
		});
		watch(() => [props.padding, viewBoxSize.value], () => {
			canvas.value.padding = props.padding;
			updateChartAreaPosAndSize();
		}, { immediate: true });
		watch(() => props.resetExtentTrigger, () => {
			canvas.value.setExtent([
				0,
				0,
				0,
				0
			]);
		});
		watch(() => touches.value, (newVal, oldVal) => {
			if (oldVal.length > 0 && newVal.length == 0) {} else if (oldVal.length == 0 && newVal.length > 0) {
				const pos1 = new Vector2(newVal[0].x, newVal[0].y);
				let pos2 = pos1.clone();
				if (newVal.length > 1) pos2 = new Vector2(newVal[1].x, newVal[1].y);
				touchZoomStart(pos1, pos2);
			} else if (oldVal.length == 2 && newVal.length == 2) touchZoomMove(new Vector2(newVal[0].x, newVal[0].y), new Vector2(newVal[1].x, newVal[1].y));
		});
		watch(() => [canvas.value.displayMax, canvas.value.displayMin], () => {
			const min = canvas.value.displayMin;
			const max = canvas.value.displayMax;
			emit("update:minmax-out", [
				min.x,
				min.y,
				max.x,
				max.y
			]);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$32, [(openBlock(), createElementBlock("svg", {
				ref_key: "svg",
				ref: svg,
				style: normalizeStyle(svgStyle.value),
				draggable: "false",
				onMousedown: onMouseDown
			}, [
				createElementVNode("defs", null, [createElementVNode("clipPath", { id: clipPathId.value }, [createElementVNode("rect", {
					x: 0,
					y: -10,
					width: canvas.value.chartAreaSize.x,
					height: canvas.value.chartAreaSize.y + 20
				}, null, 8, _hoisted_3$19)], 8, _hoisted_2$24)]),
				__props.debug ? (openBlock(), createElementBlock("rect", {
					key: 0,
					class: "v-multi-chart__viewbox-border",
					x: 0,
					y: 0,
					width: unref(viewBoxSize).x,
					height: unref(viewBoxSize).y
				}, null, 8, _hoisted_4$17)) : createCommentVNode("", true),
				__props.debug ? (openBlock(), createElementBlock("rect", {
					key: 1,
					class: "v-multi-chart__chart-area-border",
					x: canvas.value.chartAreaPos.x,
					y: canvas.value.chartAreaPos.y,
					width: canvas.value.chartAreaSize.x,
					height: canvas.value.chartAreaSize.y
				}, null, 8, _hoisted_5$6)) : createCommentVNode("", true),
				createElementVNode("g", { transform: "translate(" + canvas.value.chartAreaPos.x + "," + canvas.value.chartAreaPos.y + ")" }, [
					renderSlot(_ctx.$slots, "under"),
					createElementVNode("g", { style: normalizeStyle(`clip-path: url(#${clipPathId.value})`) }, [renderSlot(_ctx.$slots, "main")], 4),
					renderSlot(_ctx.$slots, "over")
				], 8, _hoisted_6$3)
			], 36))]);
		};
	}
});
//#endregion
//#region src/util/formatters.ts
function formatNumber(value, options = {}) {
	if (value === null || value === void 0) return "";
	if (isNaN(value)) return "";
	const numDecimals = options.numDecimals || 0;
	const decimalSeparator = options.decimalSeparator || ",";
	const thousandsSeparator = options.thousandsSeparator || ".";
	const unit = options.unit || "";
	const addSign = options.addSign || false;
	const shortThreshold = options.shortThreshold || Infinity;
	let shortChar = "";
	let shortValue = value;
	if (shortThreshold) {
		if (shortThreshold <= 1e3 && shortValue >= 1e3) {
			shortValue = value / 1e3;
			shortChar = "&nbsp;Tsd";
		}
		if (shortThreshold <= 1e6 && value >= 1e6) {
			shortValue = value / 1e6;
			shortChar = "&nbsp;Mio";
		}
	}
	value = shortValue;
	const factor = Math.pow(10, numDecimals);
	const piece = (Math.round(value * factor) / factor).toString();
	let parts = [piece];
	if (piece.includes(".")) parts = piece.split(".");
	let result = "";
	if (value > 0 && addSign) result += "+";
	result += parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
	if (numDecimals > 0) {
		let decimalsString = "";
		if (parts.length > 1) decimalsString = parts[1].substring(0, numDecimals);
		result += decimalSeparator;
		result += decimalsString.padEnd(numDecimals, "0");
	}
	result += shortChar;
	if (unit != "") result += " " + unit;
	return result;
}
function zeroPad(value, places) {
	return value.toString().padStart(places, "0");
}
//#endregion
//#region src/components/multiChart/chartDataClasses.ts
var Stack = class {
	constructor() {
		_defineProperty(this, "positive", 0);
		_defineProperty(this, "negative", 0);
		_defineProperty(this, "items", Array());
	}
};
/**
* Transforms an array of Dataset buckets into stacked column data.
* @param buckets - Array of Dataset arrays (one per group/bucket)
* @param stacked - Whether to stack positive/negative values or render them overlapping
* @param debug - Whether to log errors for missing data
*/
function buildStackData(buckets, stacked = true, debug = false) {
	const datasets = [];
	if (buckets == void 0) return {
		stackGroups: [],
		datasets: [],
		displayMin: new Vector2(Number.MAX_VALUE, 0),
		displayMax: new Vector2(Number.MIN_VALUE, Number.MIN_VALUE)
	};
	let dmin = new Vector2(Number.MAX_VALUE, 0);
	let dmax = new Vector2(Number.MIN_VALUE, Number.MIN_VALUE);
	const result = Array();
	for (let bucketIndex = 0; bucketIndex < buckets.length; bucketIndex++) {
		const bucket = buckets[bucketIndex];
		if (!bucket) continue;
		for (let datasetIndex = 0; datasetIndex < bucket.length; datasetIndex++) {
			const dataset = bucket[datasetIndex];
			if (!dataset) continue;
			if (!dataset.points) {
				if (debug) console.error(`buildStackData: Missing data for bucket index ${bucketIndex}, datasetIndex ${datasetIndex}`);
				continue;
			}
			datasets.push(dataset);
			const pairs = Array();
			for (const p of dataset.points) {
				const hash = p.x + "-" + p.y;
				if (pairs.includes(hash)) continue;
				pairs.push(hash);
				const x = p.x;
				if (result[x] == void 0) result[x] = Array();
				if (result[x][bucketIndex] == void 0) result[x][bucketIndex] = new Stack();
				const stack = result[x][bucketIndex];
				dmin.x = Math.min(dmin.x, p.x);
				dmax.x = Math.max(dmax.x, p.x);
				let y = 0;
				if (stacked) {
					if (p.y < 0) {
						y = stack.negative;
						stack.negative += p.y;
						dmin.y = Math.min(dmin.y, stack.negative);
					} else if (p.y > 0) {
						stack.positive += p.y;
						y = stack.positive;
						dmax.y = Math.max(dmax.y, stack.positive);
					}
				} else {
					y = p.y;
					dmin.y = Math.min(dmin.y, y);
					dmax.y = Math.max(dmax.y, y);
				}
				const item = {
					"dataset": dataset,
					"y": y,
					"value": p.y
				};
				stack.items.push(item);
			}
		}
	}
	return {
		stackGroups: result,
		datasets,
		displayMin: dmin,
		displayMax: dmax
	};
}
//#endregion
//#region src/components/multiChart/ColumnChart.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$31 = { class: "v-mc-column-chart" };
var _hoisted_2$23 = ["d"];
var _hoisted_3$18 = ["d"];
var _hoisted_4$16 = [
	"cx",
	"cy",
	"r",
	"data-tooltip"
];
var _hoisted_5$5 = [
	"href",
	"width",
	"height",
	"transform",
	"data-tooltip"
];
//#endregion
//#region src/components/multiChart/ColumnChart.vue
var ColumnChart_default = /* @__PURE__ */ defineComponent({
	__name: "ColumnChart",
	props: {
		pointRadius: { default: 0 },
		columnSpacingPx: { default: 6 },
		columnWidthPx: { default: 10 },
		data: {},
		drawColumns: {
			type: Boolean,
			default: true
		},
		drawLines: {
			type: Boolean,
			default: false
		},
		drawSymbols: {
			type: Boolean,
			default: true
		},
		stacked: {
			type: Boolean,
			default: true
		},
		symbolUrl: {},
		symbolSize: { default: () => new Vector2(16, 16) },
		tooltipFunc: {}
	},
	emits: ["update:legend-data"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const columnsDisplayData = ref(Array());
		const lineDisplayData = ref(Array());
		const symbolsDisplayData = ref(Array());
		let lastBuildResult = null;
		const debug = ref(false);
		const canvas = inject(chartCanvasStateKey);
		let rects = Array();
		function buildLegendData(data) {
			const result = Array();
			for (let ii = 0; ii < data.length; ii++) {
				const bucket = data[ii];
				if (!bucket) continue;
				const legendGroup = {
					label: "Gruppe " + ii,
					items: []
				};
				for (const dataset of bucket) {
					if (!dataset) {
						if (debug.value) console.error("ColumnChart buildLegendData: Missing dataset");
						continue;
					}
					const item = {
						label: dataset?.label,
						shortLabel: dataset?.shortLabel,
						style: getDatasetColumnStyle(dataset),
						symbolUrl: props.symbolUrl
					};
					legendGroup.items.push(item);
				}
				result.push(legendGroup);
			}
			return result;
		}
		function buildStackDisplayData(stackGroups, datasets) {
			const result_columnsData = {};
			const result_symbolsData = Array();
			const result_rects = Array();
			const result_linesData = Array();
			const blubb = props.columnWidthPx + props.columnSpacingPx;
			const foo = Object.keys(stackGroups);
			for (let ii = 0; ii < foo.length; ii++) {
				const stackGroupPosX_string = foo[ii];
				const stackGroup = stackGroups[stackGroupPosX_string];
				const stackGroupPosX = parseInt(stackGroupPosX_string);
				const bla = canvas.value.w2sx(stackGroupPosX) - stackGroup.length * blubb / 2;
				let sgpx_prev;
				let sgpx_next;
				if (ii > 0) {
					const gi_prev = parseInt(foo[ii - 1]);
					sgpx_prev = canvas.value.w2sx(gi_prev);
				}
				if (ii < foo.length - 1) {
					const gi_next = parseInt(foo[ii + 1]);
					sgpx_next = canvas.value.w2sx(gi_next);
				}
				for (const groupIndex_string in stackGroup) {
					const groupIndex = parseInt(groupIndex_string);
					const rx = bla + groupIndex * blubb + props.columnSpacingPx / 2;
					if (sgpx_prev !== void 0 && sgpx_prev < 0 && rx + props.columnWidthPx < 0 || sgpx_next !== void 0 && sgpx_next > canvas.value.chartAreaSize.x && rx > canvas.value.chartAreaSize.x) continue;
					if (!result_linesData[groupIndex]) result_linesData[groupIndex] = Array();
					const stack = stackGroup[groupIndex_string];
					for (const stackItemIndex_string in stack.items) {
						const stackItem = stack.items[stackItemIndex_string];
						const ry = canvas.value.w2sy(stackItem.y);
						const rh = Math.abs(stackItem.value) * canvas.value.scale.y;
						const rw = props.columnWidthPx;
						result_symbolsData.push({
							x: rx + rw / 2,
							y: ry,
							stackItem
						});
						if (!result_linesData[groupIndex][stackItemIndex_string]) result_linesData[groupIndex][stackItemIndex_string] = {
							"dataset": stackItem.dataset,
							"points": []
						};
						result_linesData[groupIndex][stackItemIndex_string].points.push({
							x: rx + rw / 2,
							y: ry
						});
						if (rh > .001) {
							const pathIndex = datasets.indexOf(stackItem.dataset);
							if (result_columnsData[pathIndex] == void 0) result_columnsData[pathIndex] = {
								path: "",
								style: getDatasetColumnStyle(stackItem.dataset)
							};
							result_columnsData[pathIndex].path += `M ${rx},${ry} l ${rw},0 l 0,${rh} l -${rw},0 l 0,-${rh} `;
							result_rects.push({
								rx,
								ry,
								rw,
								rh,
								center: rx + rw / 2,
								stackItem
							});
						}
					}
				}
			}
			symbolsDisplayData.value = result_symbolsData;
			columnsDisplayData.value = result_columnsData;
			lineDisplayData.value = [];
			for (const stack of result_linesData) {
				if (!(stack instanceof Array)) continue;
				for (const stackItem of stack) {
					const p0 = stackItem.points[0];
					let path = `M ${p0.x} ${p0.y} `;
					for (const point of stackItem.points) path += ` L ${point.x} ${point.y}`;
					lineDisplayData.value.push({
						"path": path,
						"style": getDatasetLineStyle(stackItem.dataset)
					});
				}
			}
			rects = result_rects;
		}
		function getDatasetColumnStyle(dataset) {
			const result = { fill: "#fff" };
			if (dataset.color) result.fill = dataset.color;
			return result;
		}
		function getDatasetLineStyle(dataset) {
			const result = {
				fill: "none",
				"stroke-width": "2px"
			};
			if (dataset.color) result.stroke = dataset.color;
			return result;
		}
		function getFormattedValue(series, value) {
			return formatNumber(value, { numDecimals: typeof series.numDecimals == "number" ? series.numDecimals : 1 });
		}
		function getStackItemTooltip(stackItem) {
			let tf = props.tooltipFunc;
			if (!tf) tf = (stackItem) => {
				let result = stackItem.dataset?.label ? stackItem.dataset?.label : "";
				if (result?.length > 0) result += ": ";
				result += "<strong>";
				result += getFormattedValue(stackItem.dataset, stackItem.value);
				if (stackItem.dataset?.unit) result += " " + stackItem.dataset?.unit;
				result += "</strong>";
				return result;
			};
			return tf(stackItem);
		}
		function onMouseMove(evt) {
			const mx = evt.offsetX - canvas.value.chartAreaPos.x;
			const my = evt.offsetY - canvas.value.chartAreaPos.y;
			let hover_rect = null;
			let closest_dist = Number.MAX_VALUE;
			for (const rect of rects) {
				if (mx < rect.rx || mx > rect.rx + rect.rw) continue;
				if (my < rect.ry || my > rect.ry + rect.rh) continue;
				const dist_x = Math.abs(mx - rect.center);
				if (dist_x < closest_dist) {
					closest_dist = dist_x;
					hover_rect = rect;
				}
			}
			if (hover_rect == null) return "";
			const tooltip = getStackItemTooltip(hover_rect.stackItem);
			evt.target.setAttribute("data-tooltip", tooltip);
		}
		function updateMinMax() {
			if (!lastBuildResult) return;
			const paddingVec = new Vector2(lastBuildResult.displayMax.sub(lastBuildResult.displayMin).x / 15 + .01, 0);
			const dmin = lastBuildResult.displayMin.sub(paddingVec);
			const dmax = lastBuildResult.displayMax.add(paddingVec);
			canvas.value.updateDisplayMinMax(dmin, dmax);
		}
		watch(() => props.data, () => {
			if (!props.data) return;
			const buildResult = buildStackData(props.data, props.stacked, debug.value);
			lastBuildResult = buildResult;
			buildStackDisplayData(buildResult.stackGroups, buildResult.datasets);
			const legendData = buildLegendData(props.data);
			emit("update:legend-data", legendData);
			canvas.value.onChartDataChange();
		}, {
			immediate: true,
			deep: true
		});
		watch(() => canvas.value.bottomLeftWorld, () => {
			if (!props.data || !lastBuildResult) return;
			buildStackDisplayData(lastBuildResult.stackGroups, lastBuildResult.datasets);
		}, {
			immediate: true,
			deep: true
		});
		watch(() => canvas.value.dataChangeVersion, () => {
			updateMinMax();
		}, { immediate: true });
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("g", _hoisted_1$31, [
				props.drawColumns ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(columnsDisplayData.value, (path, i) => {
					return openBlock(), createElementBlock("path", {
						key: i,
						class: "v-mc-column-chart__column",
						d: path.path,
						style: normalizeStyle(path.style),
						"data-tooltip-on-touch": "true",
						onMousemove: onMouseMove
					}, null, 44, _hoisted_2$23);
				}), 128)) : createCommentVNode("", true),
				props.drawLines ? (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(lineDisplayData.value, (stackItem, i) => {
					return openBlock(), createElementBlock("path", {
						key: i,
						class: "v-mc-column-chart__line",
						d: stackItem.path,
						style: normalizeStyle(stackItem.style),
						onMousemove: onMouseMove
					}, null, 44, _hoisted_3$18);
				}), 128)) : createCommentVNode("", true),
				props.pointRadius > 0 ? (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList(symbolsDisplayData.value, (symbol, i) => {
					return openBlock(), createElementBlock("circle", {
						key: i,
						class: "v-mc-column-chart__point",
						cx: symbol.x,
						cy: symbol.y,
						r: props.pointRadius,
						"data-tooltip": getStackItemTooltip(symbol.stackItem)
					}, null, 8, _hoisted_4$16);
				}), 128)) : createCommentVNode("", true),
				props.drawSymbols ? (openBlock(true), createElementBlock(Fragment, { key: 3 }, renderList(symbolsDisplayData.value, (symbol, i) => {
					return openBlock(), createElementBlock(Fragment, { key: i }, [symbol.stackItem.dataset.symbolUrl ? (openBlock(), createElementBlock("image", {
						key: 0,
						class: "v-mc-column-chart__symbol",
						href: symbol.stackItem.dataset.symbolUrl,
						width: props.symbolSize.x,
						height: props.symbolSize.y,
						transform: `translate(${symbol.x - props.symbolSize.x / 2}, ${symbol.y - props.symbolSize.y / 2})`,
						"data-tooltip": getStackItemTooltip(symbol.stackItem)
					}, null, 8, _hoisted_5$5)) : createCommentVNode("", true)], 64);
				}), 128)) : createCommentVNode("", true)
			]);
		};
	}
});
//#endregion
//#region src/components/multiChart/axis/useAxisRenderData.ts
/**
* Composable that creates the AxisRenderData computed property shared by all axis components.
*
* @param displayLabels - Computed ref of axis labels to display
* @param props - Component props object containing side, offset, labelAngleDeg, and dimension
* @returns Computed ref of AxisRenderData
*/
function useAxisRenderData(displayLabels, props) {
	return computed(() => ({
		side: props.side,
		offset: props.offset,
		labelAngleDeg: props.labelAngleDeg,
		dimension: props.dimension,
		displayLabels: displayLabels.value
	}));
}
//#endregion
//#region src/components/multiChart/axis/AxisRenderer.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$30 = {
	key: 0,
	class: "v-cc-axis v-cc-axis-x"
};
var _hoisted_2$22 = ["data-tooltip", "innerHTML"];
var _hoisted_3$17 = [
	"x1",
	"y1",
	"x2",
	"y2"
];
var _hoisted_4$15 = [
	"x1",
	"x2",
	"y2"
];
var _hoisted_5$4 = {
	key: 1,
	class: "v-cc-axis v-cc-axis-y"
};
var _hoisted_6$2 = [
	"x",
	"y",
	"data-tooltip",
	"innerHTML"
];
var _hoisted_7$1 = [
	"y1",
	"x2",
	"y2"
];
var _hoisted_8$1 = { key: 2 };
//#endregion
//#region src/components/multiChart/axis/AxisRenderer.vue
var AxisRenderer_default = /* @__PURE__ */ defineComponent({
	__name: "AxisRenderer",
	props: { chart: {} },
	setup(__props) {
		const props = __props;
		const canvas = inject(chartCanvasStateKey);
		function getLabelText(label) {
			if (label.text) return label.text;
			return label.pos.toString();
		}
		function getXOffset() {
			if (props.chart.side == "right") return canvas.value.chartAreaSize.x + props.chart.offset;
			else return props.chart.offset;
		}
		function getXAxisLabelStyle(label, labelAngle, canvas) {
			let transform = `translate(${canvas.w2sx(label.pos)}px, ${canvas.chartAreaSize.y + 25}px) `;
			let textAnchor = "middle";
			if (labelAngle != 0) {
				transform += `translateY(-5px) rotate(${labelAngle}deg)`;
				textAnchor = "start";
			}
			return {
				"transform": transform,
				"text-anchor": textAnchor
			};
		}
		function getLineClass(pos) {
			return { "v-cc-axis__zero-line": pos == 0 };
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("g", null, [__props.chart.dimension == "x" ? (openBlock(), createElementBlock("g", _hoisted_1$30, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.chart.displayLabels, (label) => {
				return openBlock(), createElementBlock(Fragment, { key: label.pos }, [
					createElementVNode("text", {
						style: normalizeStyle(getXAxisLabelStyle(label, __props.chart.labelAngleDeg, unref(canvas))),
						"data-tooltip": label.tooltip,
						innerHTML: getLabelText(label)
					}, null, 12, _hoisted_2$22),
					createElementVNode("line", {
						x1: unref(canvas).w2sx(label.pos),
						y1: unref(canvas).chartAreaSize.y + 10,
						x2: unref(canvas).w2sx(label.pos),
						y2: unref(canvas).chartAreaSize.y + 5
					}, null, 8, _hoisted_3$17),
					createElementVNode("line", {
						x1: unref(canvas).w2sx(label.pos),
						y1: 0,
						x2: unref(canvas).w2sx(label.pos),
						y2: unref(canvas).chartAreaSize.y,
						class: normalizeClass(getLineClass(label.pos))
					}, null, 10, _hoisted_4$15)
				], 64);
			}), 128))])) : __props.chart.dimension == "y" ? (openBlock(), createElementBlock("g", _hoisted_5$4, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.chart.displayLabels, (label) => {
				return openBlock(), createElementBlock(Fragment, { key: label.pos }, [createElementVNode("text", {
					x: getXOffset(),
					y: unref(canvas).w2sy(label.pos),
					"data-tooltip": label.tooltip,
					innerHTML: getLabelText(label)
				}, null, 8, _hoisted_6$2), createElementVNode("line", {
					x1: 0,
					y1: unref(canvas).w2sy(label.pos),
					x2: unref(canvas).chartAreaSize.x,
					y2: unref(canvas).w2sy(label.pos),
					class: normalizeClass(getLineClass(label.pos))
				}, null, 10, _hoisted_7$1)], 64);
			}), 128))])) : (openBlock(), createElementBlock("g", _hoisted_8$1, [..._cache[0] || (_cache[0] = [createElementVNode("text", null, "[ NumericalAxis error: No dimension specified ]", -1)])]))]);
		};
	}
});
//#endregion
//#region src/components/multiChart/axis/DatetimeAxis.vue?vue&type=script&setup=true&lang.ts
var msPerDay = 864e5;
var msPerHour = 36e5;
var msPerQuarterHour = 9e5;
var msPerMinute = 6e4;
//#endregion
//#region src/components/multiChart/axis/DatetimeAxis.vue
var DatetimeAxis_default = /* @__PURE__ */ defineComponent({
	__name: "DatetimeAxis",
	props: {
		dimension: {},
		labelScale: {},
		labelAngleDeg: { default: 0 },
		offset: { default: -7 },
		side: { default: "left" }
	},
	setup(__props) {
		const props = __props;
		const monthNames = [
			"Jan",
			"Feb",
			"Mär",
			"Apr",
			"Mai",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Okt",
			"Nov",
			"Dez"
		];
		const stepSizes = {
			[6]: msPerDay,
			[5]: msPerDay,
			[4]: msPerDay,
			[3]: msPerDay,
			[2]: msPerHour,
			[1]: msPerQuarterHour,
			[0]: msPerMinute
		};
		const canvas = inject(chartCanvasStateKey);
		const displayLabels = computed(() => {
			const result = Array();
			const dim = props.dimension == "x" ? 0 : 1;
			const mode = getMode(1 / canvas.value.scale.values[dim]);
			const stepSize = stepSizes[mode];
			const lowestVisibleValue = canvas.value.bottomLeftWorld.values[dim];
			let pos = Math.ceil(lowestVisibleValue / stepSize) * stepSize;
			const canvasAxisLength_world = canvas.value.chartAreaSize.values[dim] / canvas.value.scale.values[dim];
			const d = /* @__PURE__ */ new Date();
			let utcDate;
			let utcMonth;
			let utcYear;
			let text;
			while (pos <= lowestVisibleValue + canvasAxisLength_world) {
				text = "";
				d.setTime(pos);
				utcDate = d.getUTCDate();
				utcMonth = d.getUTCMonth();
				utcYear = d.getUTCFullYear();
				switch (mode) {
					case 6:
						if (utcDate == 1 && utcMonth == 0) text = utcYear.toString();
						break;
					case 5:
						if (utcDate == 1) text = monthNames[utcMonth] + " " + utcYear.toString();
						break;
					case 3:
						text = zeroPad(utcDate, 2) + "." + zeroPad(utcMonth + 1, 2) + ".";
						break;
					case 4:
						if (utcDate % 5 == 0) text = zeroPad(utcDate, 2) + "." + zeroPad(utcMonth + 1, 2);
						break;
					case 2:
					case 1:
					case 0:
						text = zeroPad(d.getUTCHours(), 2) + ":" + zeroPad(d.getUTCMinutes(), 2);
						break;
				}
				if (text != "") {
					const tooltip = zeroPad(utcDate, 2) + "." + zeroPad(utcMonth + 1, 2) + "." + utcYear + ", " + zeroPad(d.getUTCHours(), 2) + ":" + zeroPad(d.getUTCMinutes(), 2) + ":" + zeroPad(d.getUTCSeconds(), 2);
					result.push({
						"pos": pos,
						"text": text,
						"tooltip": tooltip
					});
				}
				pos += stepSize;
			}
			return result;
		});
		function getMode(scale) {
			if (typeof props.labelScale == "string") switch (props.labelScale) {
				case "year": return 6;
				case "month": return 5;
			}
			let mode = 0;
			if (scale > 4e7) mode = 6;
			else if (scale > 7e6) mode = 5;
			else if (scale > 2e6) mode = 4;
			else if (scale > 7e4) mode = 3;
			else if (scale > 15e3) mode = 2;
			else if (scale > 1400) mode = 1;
			else if (scale > 0) mode = 0;
			return mode;
		}
		const chart = useAxisRenderData(displayLabels, props);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(AxisRenderer_default, { chart: unref(chart) }, null, 8, ["chart"]);
		};
	}
});
//#endregion
//#region src/components/multiChart/axis/NumericalAxis.vue
var NumericalAxis_default = /* @__PURE__ */ defineComponent({
	__name: "NumericalAxis",
	props: {
		axisSteps: { default: () => [
			1,
			2,
			5,
			10,
			25,
			50,
			100,
			250,
			500,
			1e3,
			2500,
			5e3,
			1e4,
			25e3,
			5e4,
			1e5,
			25e4,
			5e5,
			1e6,
			25e5,
			5e6,
			1e7,
			25e6,
			5e7
		] },
		dimension: {},
		labelAngleDeg: { default: 0 },
		numDecimals: { default: 0 },
		offset: { default: -7 },
		side: { default: "left" },
		targetPixelsPerAxisStep: { default: 30 }
	},
	setup(__props) {
		const props = __props;
		const cfg_reduceSteps = [{
			num: 1e9,
			label: "Mrd."
		}, {
			num: 1e6,
			label: "Mio."
		}];
		const canvas = inject(chartCanvasStateKey);
		function autoFit() {
			const dim = props.dimension == "x" ? 0 : 1;
			const min = canvas.value.displayMin.clone();
			const max = canvas.value.displayMax.clone();
			const newMin = getNextAxisStep(min.values[dim], true);
			const newMax = getNextAxisStep(max.values[dim], false);
			if (max.values[dim] != newMax || min.values[dim] != newMin) {
				min.values[dim] = newMin;
				max.values[dim] = newMax;
				canvas.value.updateDisplayMinMax(min, max);
			}
		}
		const displayLabels = computed(() => {
			const dim = props.dimension == "x" ? 0 : 1;
			const result = Array();
			const labelDistance_px = getLabelStep();
			const lowestVisibleValue = canvas.value.bottomLeftWorld.values[dim];
			let pos = getNextAxisStep(lowestVisibleValue, true);
			const canvasAxisLength_world = Math.ceil(canvas.value.chartAreaSize.values[dim] / canvas.value.scale.values[dim]);
			while (pos <= lowestVisibleValue + canvasAxisLength_world) {
				if (pos < canvas.value.bottomLeftWorld.values[dim]) {
					pos += labelDistance_px;
					continue;
				}
				let value = pos;
				let text = formatNumber(pos, { numDecimals: props.numDecimals });
				if (value >= 1e4) {
					for (const rs of cfg_reduceSteps) if (value < -rs.num || value > rs.num) {
						value /= rs.num;
						text = value + " " + rs.label;
					}
				}
				result.push({
					pos,
					text
				});
				pos += labelDistance_px;
			}
			return result;
		});
		function getLabelStep() {
			const dim = props.dimension == "x" ? 0 : 1;
			const canvasSizeDim = canvas.value.chartAreaSize.values[dim];
			const canvasScaleDim = canvas.value.scale.values[dim];
			if (canvasScaleDim == 0) return 1;
			const numSteps = canvasSizeDim / props.targetPixelsPerAxisStep;
			let result = canvasSizeDim / canvasScaleDim / numSteps;
			const axisSteps = props.axisSteps;
			for (let ii = 0; ii < axisSteps.length; ii++) if (axisSteps[ii] >= result || ii == axisSteps.length - 1) {
				result = axisSteps[ii];
				break;
			}
			return result;
		}
		function getNextAxisStep(value, down) {
			const stepSize = getLabelStep();
			let result = Math.ceil(value / stepSize) * stepSize;
			if (down && value < result) result -= stepSize;
			return result;
		}
		watch(() => [canvas.value.bottomLeftWorld, canvas.value.chartAreaSize], () => {
			autoFit();
		}, { deep: true });
		const chart = useAxisRenderData(displayLabels, props);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(AxisRenderer_default, { chart: unref(chart) }, null, 8, ["chart"]);
		};
	}
});
//#endregion
//#region src/components/multiChart/axis/CustomAxis.vue
var CustomAxis_default = /* @__PURE__ */ defineComponent({
	__name: "CustomAxis",
	props: {
		dimension: {},
		labels: { default: () => [] },
		labelAngleDeg: { default: 0 },
		offset: { default: -7 },
		side: { default: "left" }
	},
	setup(__props) {
		const props = __props;
		const canvas = inject(chartCanvasStateKey);
		const displayLabels = computed(() => {
			const dim = props.dimension == "x" ? 0 : 1;
			const result = Array();
			const lowestVisibleValue = canvas.value.bottomLeftWorld.values[dim];
			const canvasAxisLength_world = canvas.value.chartAreaSize.values[dim] / canvas.value.scale.values[dim];
			for (const label of props.labels) {
				if (label.pos < lowestVisibleValue || label.pos > lowestVisibleValue + canvasAxisLength_world) continue;
				result.push(label);
			}
			return result;
		});
		function autoFit() {
			const dim = props.dimension == "x" ? 0 : 1;
			const min = canvas.value.displayMin.clone();
			const max = canvas.value.displayMax.clone();
			let newMin = Number.MAX_VALUE;
			let newMax = Number.MIN_VALUE;
			for (const label of props.labels) {
				if (max.values[dim] >= label.pos) newMax = label.pos;
				if (min.values[dim] <= label.pos) newMin = label.pos;
			}
			if (max.values[dim] != newMax || min.values[dim] != newMin) {
				max.values[dim] = newMax;
				min.values[dim] = newMin;
				canvas.value.updateDisplayMinMax(min, max);
			}
		}
		watch(() => [canvas.value.bottomLeftWorld, canvas.value.chartAreaSize], () => {
			autoFit();
		});
		const chart = useAxisRenderData(displayLabels, props);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(AxisRenderer_default, { chart: unref(chart) }, null, 8, ["chart"]);
		};
	}
});
//#endregion
//#region src/components/SmartButton.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$29 = ["disabled"];
var _hoisted_2$21 = ["disabled"];
//#endregion
//#region src/components/SmartButton.vue
var SmartButton_default = /* @__PURE__ */ defineComponent({
	__name: "SmartButton",
	props: {
		boolean: { type: Boolean },
		modelValue: {},
		set: {},
		unset: {}
	},
	emits: ["click", "update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const button_set = ref(null);
		const button_unset = ref(null);
		const emit = __emit;
		let unsetButtonHasFocus = false;
		const dynamicClass = computed(() => {
			return {
				"v-smart-button": true,
				"x-disabled": isDisabled.value,
				"x-selected": isChecked.value
			};
		});
		const isChecked = computed(() => {
			if (props.modelValue === val_set()) return true;
			try {
				if (JSON.stringify(props.modelValue) === JSON.stringify(val_set())) return true;
			} catch (e) {}
			return false;
		});
		const isDisabled = computed(() => {
			return props.modelValue === val_set() && (props.modelValue === val_unset() || val_unset() === void 0);
		});
		function onBlur() {
			window.setTimeout(() => {
				if (unsetButtonHasFocus) {
					if (button_set.value != null) button_set.value.focus();
				} else if (button_unset.value != null) button_unset.value.focus();
			}, 0);
		}
		function onFocus() {
			unsetButtonHasFocus = isChecked.value;
		}
		function onSetClick(evt) {
			emit("update:modelValue", val_set());
			emit("click", evt);
		}
		function onUnsetClick(evt) {
			if (val_unset() !== void 0) emit("update:modelValue", val_unset());
			emit("click", evt);
		}
		function val_set() {
			if (props.boolean) return true;
			return props.set;
		}
		function val_unset() {
			if (props.boolean) return false;
			return props.unset;
		}
		return (_ctx, _cache) => {
			return isChecked.value ? (openBlock(), createElementBlock("button", {
				key: 0,
				ref_key: "button_unset",
				ref: button_unset,
				disabled: isDisabled.value,
				class: normalizeClass(dynamicClass.value),
				onClick: onUnsetClick,
				onFocus,
				onBlur
			}, [renderSlot(_ctx.$slots, "default")], 42, _hoisted_1$29)) : (openBlock(), createElementBlock("button", {
				key: 1,
				ref_key: "button_set",
				ref: button_set,
				disabled: isDisabled.value,
				class: normalizeClass(dynamicClass.value),
				onClick: onSetClick,
				onFocus,
				onBlur
			}, [renderSlot(_ctx.$slots, "default")], 42, _hoisted_2$21));
		};
	}
});
//#endregion
//#region src/components/maplibre/MapLibreMap.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$28 = ["data-tooltip"];
var _hoisted_2$20 = {
	key: 0,
	class: "v-ml-map__no-layers-info"
};
var _hoisted_3$16 = { class: "v-ml-map__map-config-view" };
var defaultGlyphsUrl = "https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf";
var MapLibreMap_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "MapLibreMap",
	props: {
		style: { default: () => ({}) },
		mapModules: { default: () => Array() },
		options: { default: () => ({}) },
		showMapConfig: {
			type: Boolean,
			default: () => false
		}
	},
	emits: [
		"featureClick",
		"featureIn",
		"featureOut",
		"update:dataLoadingOut",
		"update:stateOut",
		"update:showMapConfig"
	],
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const _showMapConfig = computed({
			get: () => props.showMapConfig,
			set(newval) {
				emit("update:showMapConfig", newval);
			}
		});
		const dynamicClass = computed(() => {
			return {
				"v-maplibre-map": true,
				"v-maplibre-map--hover": prevHoverFeature.value != null
			};
		});
		const noVisibleLayers = computed(() => {
			let noVisibleLayers = true;
			for (const layer of props.style?.layers || []) if (!layer.layout?.visibility || layer.layout.visibility == "visible") noVisibleLayers = false;
			return noVisibleLayers;
		});
		const mapContainerRef = ref(null);
		const mapModules = Array();
		const loadedSymbolImages = /* @__PURE__ */ new Set();
		const tooltip = ref("");
		let currentlyLoadingSources = /* @__PURE__ */ new Set();
		const prevHoverFeature = ref(null);
		let prevHoverFeatureStringified = "";
		let resizeTimeout = null;
		function debouncedResize() {
			if (resizeTimeout !== null) clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				onResize();
				resizeTimeout = null;
			}, 16);
		}
		useOnElementResize(mapContainerRef, debouncedResize);
		const mapRef = ref();
		const map = new Promise((resolve) => {
			watch(() => mapRef.value, (newValue) => {
				if (newValue instanceof Map$1) resolve(newValue);
			}, { immediate: true });
		});
		let initialExtentSet = false;
		let currentExtent = [];
		async function emitState() {
			const m = await map;
			const zoom = m.getZoom();
			const lat_rad = m.getCenter().lat * Math.PI / 180;
			const res = 40075016.686 * Math.cos(lat_rad) / (512 * Math.pow(2, zoom));
			emit("update:stateOut", {
				extent: m.getBounds().toArray().flat(),
				center: m.getCenter().toArray().flat(),
				zoom,
				resolution: res
			});
		}
		/**
		* Returns the map module that owns the given feature, based on the
		* `moduleConfig.uuid + "_"` prefix that is applied to all layer ids
		* when a module's style is registered. Returns `undefined` if no
		* module claims the feature.
		*/
		function findMapModuleForFeature(feature) {
			if (!feature?.layer?.id) return;
			return mapModules.find((m) => feature.layer.id.startsWith(m.uuid + "_"));
		}
		async function fitBounds(bounds, options) {
			(await map).fitBounds([[bounds[0], bounds[1]], [bounds[2], bounds[3]]], {
				animate: options?.animate || false,
				padding: options?.padding || 0
			}, { originalEvent: { type: "programmatic" } });
		}
		async function flyTo(coordinates, zoom) {
			const m = await map;
			const c = new LngLat(coordinates[0], coordinates[1]);
			m.flyTo({
				center: c,
				zoom,
				duration: 1e3
			}, { originalEvent: { type: "programmatic" } });
		}
		async function saveMapImage() {
			const url = (await map).getCanvas().toDataURL("image/png");
			const a = document.createElement("a");
			a.href = url;
			a.download = "map.png";
			a.click();
		}
		function onData(e) {
			currentlyLoadingSources.delete(e.sourceId);
			emit("update:dataLoadingOut", currentlyLoadingSources.size !== 0);
		}
		function onDataAbort(e) {
			currentlyLoadingSources.delete(e.sourceId);
			emit("update:dataLoadingOut", currentlyLoadingSources.size !== 0);
		}
		function onDataLoading(e) {
			currentlyLoadingSources.add(e.sourceId);
			emit("update:dataLoadingOut", currentlyLoadingSources.size !== 0);
		}
		async function onMapClick(e) {
			const m = await map;
			const b = m.getBounds();
			const container = m.getContainer();
			const mapViewport = {
				bounds: {
					west: b.getWest(),
					south: b.getSouth(),
					east: b.getEast(),
					north: b.getNorth()
				},
				width: container.clientWidth,
				height: container.clientHeight
			};
			const lngLat = {
				lng: e.lngLat.lng,
				lat: e.lngLat.lat
			};
			const featuresUnderMouse = m.queryRenderedFeatures(e.point);
			let topFeature = null;
			for (let feature of featuresUnderMouse) {
				const owningModule = findMapModuleForFeature(feature);
				if (!owningModule || owningModule.ignorePointerEvents) continue;
				topFeature = feature;
				break;
			}
			if (topFeature) {
				const topFeatureClone = JSON.parse(JSON.stringify(topFeature));
				for (const key in topFeatureClone.properties) try {
					topFeatureClone.properties[key] = JSON.parse(topFeatureClone.properties[key]);
				} catch (e) {}
				topFeature = topFeatureClone;
			}
			const event = {
				feature: topFeature,
				button: e.originalEvent?.button,
				pixelPoint: {
					x: e.point.x,
					y: e.point.y
				},
				lngLat,
				mapViewport
			};
			const owningModule = findMapModuleForFeature(topFeature);
			if (owningModule) owningModule.onFeatureClick(event);
			for (const mapModule of mapModules) {
				if (mapModule == owningModule) continue;
				mapModule.onOutsideClick(event);
			}
		}
		async function onMapMouseMove(e) {
			const m = await map;
			const lngLatForHook = {
				lng: e.lngLat.lng,
				lat: e.lngLat.lat
			};
			for (const mapModule of mapModules) mapModule.onMapMouseMove(lngLatForHook);
			const featuresUnderMouse = m.queryRenderedFeatures(e.point);
			let topFeature = null;
			for (let feature of featuresUnderMouse) {
				const owningModule = findMapModuleForFeature(feature);
				if (!owningModule || owningModule.ignorePointerEvents) continue;
				topFeature = feature;
				break;
			}
			const currentHoverFeatureStringified = JSON.stringify(topFeature);
			if (currentHoverFeatureStringified == prevHoverFeatureStringified) return;
			if (prevHoverFeature.value) {
				const event = { feature: prevHoverFeature.value };
				for (const controller of mapModules) if (controller.onFeatureOut) controller.onFeatureOut(event);
			}
			tooltip.value = "";
			prevHoverFeature.value = topFeature;
			prevHoverFeatureStringified = currentHoverFeatureStringified;
			if (topFeature) {
				const topFeatureClone = JSON.parse(prevHoverFeatureStringified);
				for (const key in topFeatureClone.properties) try {
					topFeatureClone.properties[key] = JSON.parse(topFeatureClone.properties[key]);
				} catch (e) {}
				const event = { feature: topFeatureClone };
				const owningModule = findMapModuleForFeature(topFeature);
				if (owningModule) {
					owningModule.onFeatureIn(event);
					if (owningModule.tooltipFunc) {
						const tt = owningModule.tooltipFunc(topFeatureClone);
						tooltip.value = tt || "";
					}
				}
			}
		}
		async function onMapMoveEnd(e) {
			const m = await map;
			if (e.originalEvent != void 0) currentExtent = m.getBounds().toArray().flat();
			emitState();
		}
		async function onMapLoad() {
			const m = await map;
			setTimeout(() => {
				currentExtent = m.getBounds().toArray().flat();
			}, 100);
		}
		async function onResize() {
			const m = await map;
			if (currentExtent.length == 4) {
				const preservedExtent = [...currentExtent];
				m.resize();
				requestAnimationFrame(() => {
					m.fitBounds(preservedExtent, {
						animate: true,
						padding: 0,
						duration: 200
					});
					requestAnimationFrame(() => {
						emitState();
					});
				});
			} else {
				m.resize();
				requestAnimationFrame(() => {
					currentExtent = m.getBounds().toArray().flat();
					emitState();
				});
			}
		}
		async function setFilter(layerId, filter) {
			const m = await map;
			try {
				if (!m.getLayer(layerId)) return;
				m.setFilter(layerId, filter);
			} catch (e) {}
		}
		async function setLayoutProperty(layerId, name, value) {
			const m = await map;
			try {
				m.setLayoutProperty(layerId, name, value);
			} catch (e) {}
		}
		async function setPaintProperty(layerId, name, value) {
			const m = await map;
			try {
				m.setPaintProperty(layerId, name, value);
			} catch (e) {}
		}
		function setTooltip(tt) {
			tooltip.value = tt;
		}
		onMounted(() => {
			if (!mapContainerRef.value) return;
			const m = new Map$1({
				container: mapContainerRef.value,
				style: {
					version: 8,
					sources: {},
					layers: [],
					glyphs: defaultGlyphsUrl
				},
				doubleClickZoom: false,
				dragRotate: props.options.allowRotate ?? false,
				touchZoomRotate: true,
				attributionControl: false
			});
			const attribution = new AttributionControl({ compact: true });
			m.addControl(attribution, "bottom-left");
			if (!props.options.allowRotate) m.touchZoomRotate.disableRotation();
			m.touchPitch.disable();
			m.on("click", onMapClick);
			m.on("contextmenu", onMapClick);
			m.on("data", onData);
			m.on("dataabort", onDataAbort);
			m.on("dataloading", onDataLoading);
			m.on("load", onMapLoad);
			m.on("mousemove", onMapMouseMove);
			m.on("moveend", onMapMoveEnd);
			m.on("styleimagemissing", async (e) => {
				const imageUrl = e.id;
				if (loadedSymbolImages.has(imageUrl)) return;
				loadedSymbolImages.add(imageUrl);
				try {
					const res = await m.loadImage(imageUrl);
					if (res) {
						if (!m.hasImage(imageUrl)) m.addImage(imageUrl, res.data);
					} else {
						console.warn(`[MapLibreMap] Failed to load icon image: ${imageUrl}`);
						loadedSymbolImages.delete(imageUrl);
					}
					console.log("Loading style image " + imageUrl);
				} catch (err) {
					console.warn(`[MapLibreMap] Error loading icon image: ${imageUrl}`, err);
					loadedSymbolImages.delete(imageUrl);
				}
			});
			mapRef.value = m;
		});
		onUnmounted(() => {
			map.then((m) => m.remove());
		});
		emit("update:dataLoadingOut", false);
		/**
		* Apply a new MapLibre style. Called imperatively by MapView whenever
		* updateMap() produces a genuinely new style object. Using an explicit
		* method call instead of a prop watcher avoids Vue's reactive proxy
		* wrapping, which causes reference equality checks to always fail and
		* results in spurious m.setStyle() calls on every pan/zoom/tile event.
		*/
		async function applyStyle(newStyle) {
			const m = await map;
			if (newStyle.initialExtent && !initialExtentSet) {
				m.fitBounds(newStyle.initialExtent, {
					animate: false,
					padding: 0
				}, { originalEvent: { type: "programmatic" } });
				initialExtentSet = true;
			}
			const sources = newStyle.sources || {};
			const layers = newStyle.layers || [];
			loadedSymbolImages.clear();
			m.setStyle({
				version: 8,
				sources,
				layers,
				glyphs: newStyle.glyphs || defaultGlyphsUrl
			});
			m.once("styledata", () => {
				for (const module of mapModules) module.reapplyStyleOverrides();
			});
		}
		watch(() => props.mapModules, async (newMapModules) => {
			mapModules.length = 0;
			const actions = {
				fitBounds,
				flyTo,
				setTooltip,
				setLayoutProperty,
				setPaintProperty,
				setFilter
			};
			for (const module of newMapModules) {
				mapModules.push(module);
				module.map = actions;
			}
		}, { immediate: true });
		__expose({
			fitBounds,
			saveMapImage,
			applyStyle
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(dynamicClass.value) }, [
				createElementVNode("div", {
					ref_key: "mapContainerRef",
					ref: mapContainerRef,
					class: "v-ml-map__container",
					"data-tooltip": tooltip.value,
					role: "application",
					"aria-label": "Interaktive Karte"
				}, null, 8, _hoisted_1$28),
				noVisibleLayers.value ? (openBlock(), createElementBlock("div", _hoisted_2$20, " Die Karte enthält keine sichtbaren Ebenen. ")) : createCommentVNode("", true),
				props.showMapConfig ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [createElementVNode("div", _hoisted_3$16, [createElementVNode("pre", null, toDisplayString(JSON.stringify(props.style, null, 2)) + " ", 1)]), createVNode(SmartButton_default, {
					class: "v-ml-map__map-config-display-toggle",
					modelValue: _showMapConfig.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _showMapConfig.value = $event),
					"data-tooltip": "Kartenkonfigurationsansicht schließen"
				}, {
					default: withCtx(() => [..._cache[1] || (_cache[1] = [createTextVNode("x", -1)])]),
					_: 1
				}, 8, ["modelValue"])], 64)) : createCommentVNode("", true)
			], 2);
		};
	}
});
//#endregion
//#region \0plugin-vue:export-helper
var _plugin_vue_export_helper_default = (sfc, props) => {
	const target = sfc.__vccOpts || sfc;
	for (const [key, val] of props) target[key] = val;
	return target;
};
//#endregion
//#region src/components/maplibre/MapLibreMap.vue
var MapLibreMap_default = /* @__PURE__ */ _plugin_vue_export_helper_default(MapLibreMap_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-8070dff1"]]);
//#endregion
//#region src/components/maplibre/AbstractMapModule.ts
var AbstractMapModule = class {
	/** The current opacity value of this module's layers (0–1). */
	get opacity() {
		return this.reactiveData.opacity ?? 1;
	}
	/**
	* Updates the opacity of all MapLibre layers belonging to this module
	* by setting the appropriate paint property on each live layer.
	* The opacity value is clamped to [0, 1].
	*/
	set opacity(newVal) {
		const clamped = Math.max(0, Math.min(1, newVal));
		this.reactiveData.opacity = clamped;
		for (const layer of this.reactiveData.activeStyle?.layers || []) {
			if (!layer.id.startsWith(this.uuid + "_")) continue;
			if (this.map) this.map.setLayoutProperty(layer.id, "visibility", clamped > 0 ? "visible" : "none");
			const paintProp = this.getOpacityPaintProperty(layer.type);
			if (paintProp) {
				const layerOpacity = layer.paint?.[paintProp] ?? 1;
				this.map?.setPaintProperty(layer.id, paintProp, clamped * layerOpacity);
			}
		}
	}
	get visible() {
		return this.opacity > 0;
	}
	set visible(newVal) {
		this.opacity = newVal ? this.moduleConfig.opacity || 1 : 0;
	}
	getLegendData() {
		return null;
	}
	constructor(config) {
		_defineProperty(this, "uuid", uuid.v4().toString());
		_defineProperty(this, "ignorePointerEvents", false);
		_defineProperty(this, "reactiveData", reactive({
			visible: true,
			opacity: 1
		}));
		_defineProperty(this, "map", void 0);
		this.moduleConfig = config;
		let opacity = config.opacity;
		if (!opacity && opacity !== 0) opacity = 1;
		this.reactiveData.opacity = opacity;
		this.ignorePointerEvents = this.moduleConfig.ignorePointerEvents || false;
	}
	/**
	* Lifecycle method called by MapView after the module is constructed and
	* updateMap callback is assigned. Override in subclasses to perform
	* initialization that requires the updateMap callback to be available.
	* 
	* The base implementation applies the initial style from moduleConfig if present.
	*/
	init() {
		if (this.moduleConfig.style) this.setStyle(this.moduleConfig.style);
	}
	/** Called when the user clicks a feature belonging to this module. Override to handle. */
	onFeatureClick(e) {}
	/** Called then the user clicks on a point that is *not* a feature of this module */
	onOutsideClick(e) {}
	/** Called when the cursor enters a feature belonging to this module. */
	onFeatureIn(e) {}
	/** Called when the cursor leaves a feature belonging to this module. */
	onFeatureOut(e) {}
	/**
	* Called on every map mouse-move event with the current WGS84 cursor position.
	* Override to react to per-pixel coordinate changes (e.g. raster value queries).
	* Keep implementations lightweight — this fires on every move pixel.
	*/
	onMapMouseMove(lngLat) {}
	/**
	* Returns all layers whose id starts with `prefix`.
	* Used to locate hover/select highlight layers by their module-scoped prefix.
	*/
	findLayersWithPrefix(prefix) {
		const result = [];
		for (const layer of this.reactiveData.activeStyle?.layers || []) if (prefix ? layer.id.startsWith(prefix) : true) result.push(layer);
		return result;
	}
	/**
	* The method prepareStyle() takes the map module's style object and applies some
	* modifications before it is inserted to the actual MapLibre map configuration:
	* 
	* - Prefix all source and layer IDs in a style with the module's UUID to avoid
	*   naming conflicts between different map modules.
	* 
	* - Adjust each layer's opacity according to the map-module-level opacity value.
	*/
	prepareStyle(style) {
		const preparedStyle = JSON.parse(JSON.stringify(style));
		const uuid = this.uuid;
		const newSources = {};
		for (const sourceId in preparedStyle.sources) newSources[uuid + "_" + sourceId] = preparedStyle.sources[sourceId];
		preparedStyle.sources = newSources;
		for (const layer of preparedStyle.layers || []) {
			layer.id = uuid + "_" + layer.id;
			layer.source = uuid + "_" + layer.source;
			if (preparedStyle.sources[layer.source]?.type === "vector") layer["source-layer"] = "features";
		}
		return preparedStyle;
	}
	/**
	* Returns the MapLibre paint property name for opacity based on layer type.
	*/
	getOpacityPaintProperty(layerType) {
		switch (layerType) {
			case "circle": return "circle-opacity";
			case "fill": return "fill-opacity";
			case "line": return "line-opacity";
			case "raster": return "raster-opacity";
			default: return null;
		}
	}
	setAllLayersVisibility(visible) {
		this.visible = visible;
	}
	setStyle(style) {
		this.reactiveData.activeStyle = this.prepareStyle(style);
	}
	/**
	* Called by MapLibreMap after every `m.setStyle()` completes (on the `styledata`
	* event). Override in subclasses to reapply any layout overrides that were wiped
	* by the full style reload — e.g. hover/select filter expressions.   
	*/
	reapplyStyleOverrides() {}
	tooltipFunc(feature) {
		return null;
	}
};
//#endregion
//#region src/components/ViewStack/ViewStack.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$27 = { class: "v-view-stack" };
var _hoisted_2$19 = { class: "v-view-stack__item__header" };
var _hoisted_3$15 = [
	"data-tooltip",
	"disabled",
	"onClick",
	"innerHTML"
];
var _hoisted_4$14 = ["data-tooltip", "onClick"];
var _hoisted_5$3 = ["inert"];
//#endregion
//#region src/components/ViewStack/ViewStack.vue
var ViewStack_default = /* @__PURE__ */ defineComponent({
	__name: "ViewStack",
	props: { controller: {} },
	setup(__props) {
		const props = __props;
		function extendedProps(item) {
			return {
				...item.props,
				viewStackItem: item
			};
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$27, [createVNode(TransitionGroup, {
				name: "view-stack-slide",
				tag: "ul"
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(props.controller.items, (item, index) => {
					return openBlock(), createElementBlock("li", {
						key: item.id,
						class: normalizeClass({
							"v-view-stack__item": true,
							"x-top": index === props.controller.items.length - 1,
							"x-covered": index < props.controller.items.length - 1
						}),
						style: normalizeStyle(`top:${index * 30}px;left:${index * 0}px;`)
					}, [createElementVNode("header", _hoisted_2$19, [createElementVNode("h2", null, [createElementVNode("button", {
						"data-tooltip": `Zurück zum Panel '${item.title}'`,
						disabled: item == props.controller.topItem,
						onClick: ($event) => index < props.controller.items.length - 1 && __props.controller.popToIndex(index),
						innerHTML: item.title
					}, null, 8, _hoisted_3$15)]), index > 0 && index == props.controller.items.length - 1 ? (openBlock(), createElementBlock("button", {
						key: 0,
						"data-tooltip": `Panel '${item.title}' schließen`,
						class: "v-atlas-stack-back-button",
						onClick: ($event) => __props.controller.removeItemAtIndex(index)
					}, [..._cache[0] || (_cache[0] = [createElementVNode("span", null, "Zurück", -1)])], 8, _hoisted_4$14)) : createCommentVNode("", true)]), createElementVNode("div", {
						class: "v-view-stack__item-content",
						inert: index < props.controller.items.length - 1
					}, [(openBlock(), createBlock(resolveDynamicComponent(item.componentName), mergeProps({ ref_for: true }, extendedProps(item)), null, 16))], 8, _hoisted_5$3)], 6);
				}), 128))]),
				_: 1
			})]);
		};
	}
});
//#endregion
//#region src/components/ViewStack/ViewStackController.ts
var ViewStackController = class {
	constructor() {
		_defineProperty(this, "items", reactive([]));
	}
	addItem(item) {
		const existingItemIndex = this.items.findIndex((i) => i.role === item.role);
		if (existingItemIndex !== -1) {
			this.popToIndex(existingItemIndex);
			this.items.splice(existingItemIndex, 1);
		}
		item.props.viewStackController = this;
		this.items.push(item);
	}
	popItem() {
		if (this.items.length > 1) this.items.pop();
	}
	/** Pop all items above the given index so that `items[index]` becomes the top item. */
	popToIndex(index) {
		if (index >= 0 && index < this.items.length - 1) this.items.splice(index + 1);
	}
	removeItemAtIndex(index) {
		if (index >= 0 && index < this.items.length) this.items.splice(index, 1);
	}
	get topItem() {
		if (this.items.length > 0) return this.items[this.items.length - 1];
		return null;
	}
};
//#endregion
//#region src/components/contextMenu/contextMenu.ts
/** Reactive singleton that controls the global context menu state. */
var contextMenu = reactive({
	visible: false,
	x: 0,
	y: 0,
	items: [],
	/** Show the context menu at the given pixel coordinates with the given items. */
	open(items, x, y) {
		this.items = items;
		this.x = x;
		this.y = y;
		this.visible = true;
	},
	/** Hide the context menu and clear its items. */
	close() {
		this.visible = false;
		this.items = [];
	}
});
//#endregion
//#region src/components/contextMenu/ContextMenu.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$26 = { class: "v-context-menu__list" };
var _hoisted_2$18 = ["onClick"];
//#endregion
//#region src/components/contextMenu/ContextMenu.vue
var ContextMenu_default = /* @__PURE__ */ defineComponent({
	__name: "ContextMenu",
	setup(__props) {
		const menuRef = ref(null);
		function onItemClick(item) {
			item.action();
			contextMenu.close();
		}
		function onDocumentMouseDown(e) {
			if (contextMenu.visible && menuRef.value && !menuRef.value.contains(e.target)) contextMenu.close();
		}
		onMounted(() => {
			document.addEventListener("mousedown", onDocumentMouseDown);
		});
		onUnmounted(() => {
			document.removeEventListener("mousedown", onDocumentMouseDown);
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Teleport, { to: "body" }, [unref(contextMenu).visible ? (openBlock(), createElementBlock("div", {
				key: 0,
				ref_key: "menuRef",
				ref: menuRef,
				class: "v-context-menu",
				style: normalizeStyle({
					left: unref(contextMenu).x + "px",
					top: unref(contextMenu).y + "px"
				})
			}, [createElementVNode("ul", _hoisted_1$26, [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(contextMenu).items, (item, index) => {
				return openBlock(), createElementBlock("li", {
					key: index,
					class: "v-context-menu__item",
					onClick: ($event) => onItemClick(item)
				}, toDisplayString(item.label), 9, _hoisted_2$18);
			}), 128))])], 4)) : createCommentVNode("", true)]);
		};
	}
});
//#endregion
//#region src/components/legend/Legend.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$25 = { class: "v-legend" };
var _hoisted_2$17 = { class: "v-legend__group" };
var _hoisted_3$14 = { class: "v-legend__group__label" };
var _hoisted_4$13 = { class: "v-legend__group__items-wrapper" };
var _hoisted_5$2 = ["data-tooltip"];
var _hoisted_6$1 = { class: "v-legend__symbol-wrapper" };
var _hoisted_7 = ["src"];
var _hoisted_8 = { key: 1 };
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = ["onClick"];
var _hoisted_11 = { class: "v-legend__symbol-wrapper" };
var _hoisted_12 = ["src"];
var _hoisted_13 = { key: 1 };
var _hoisted_14 = ["innerHTML"];
var _hoisted_15 = { key: 0 };
//#endregion
//#region src/components/legend/Legend.vue
var Legend_default = /* @__PURE__ */ defineComponent({
	__name: "Legend",
	props: {
		data: {},
		highlight: {},
		mode: { default: "div" }
	},
	emits: ["update:selected"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const selectedIds = ref(/* @__PURE__ */ new Set());
		function getItemKey(item) {
			return item.id ?? item.label;
		}
		function resolveSelectedItems() {
			const out = [];
			if (!props.data?.groups) return out;
			for (const g of props.data.groups) {
				if (!g?.items || !Array.isArray(g.items)) continue;
				for (const it of g.items) if (selectedIds.value.has(getItemKey(it))) out.push(it);
			}
			return out;
		}
		function toggleItem(item) {
			const label = getItemKey(item);
			if (selectedIds.value.has(label)) selectedIds.value.delete(label);
			else selectedIds.value.add(label);
			emit("update:selected", resolveSelectedItems());
		}
		function initializeSelection() {
			const allItems = [];
			if (props.data?.groups) {
				for (const group of props.data.groups) if (group?.items && Array.isArray(group.items)) allItems.push(...group.items);
				const keys = allItems.map(getItemKey);
				selectedIds.value = new Set(keys);
			}
		}
		onMounted(() => {
			initializeSelection();
		});
		watch(() => props.data, (oldVal, newVal) => {
			if (JSON.stringify(oldVal) === JSON.stringify(newVal)) return;
			initializeSelection();
		}, { deep: true });
		function getDynamicClass(item) {
			let highlight = false;
			if (typeof item.highlightFunc === "function") highlight = item.highlightFunc(props.highlight);
			return {
				"v-legend__item": true,
				"v-legend__item--highlight": highlight
			};
		}
		function getItemLabel(item) {
			if (item.shortLabel) return item.shortLabel;
			return item.label;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$25, [__props.data && __props.data.groups ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(__props.data.groups, (group) => {
				return openBlock(), createElementBlock("div", _hoisted_2$17, [createElementVNode("div", _hoisted_3$14, toDisplayString(group.label), 1), createElementVNode("div", _hoisted_4$13, [group && group.items && group.items instanceof Array ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [(openBlock(true), createElementBlock(Fragment, null, renderList(group.items, (item) => {
					return openBlock(), createElementBlock("div", {
						class: normalizeClass(getDynamicClass(item)),
						"data-tooltip": item.label
					}, [__props.mode === "div" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("div", _hoisted_6$1, [item.symbolUrl ? (openBlock(), createElementBlock("img", {
						key: 0,
						src: item.symbolUrl
					}, null, 8, _hoisted_7)) : (openBlock(), createElementBlock("svg", _hoisted_8, [createElementVNode("rect", { style: normalizeStyle(item.style) }, null, 4)]))]), item.label ? (openBlock(), createElementBlock("div", {
						key: 0,
						class: "v-legend__item__label",
						innerHTML: getItemLabel(item)
					}, null, 8, _hoisted_9)) : createCommentVNode("", true)], 64)) : __props.mode === "button" ? (openBlock(), createElementBlock("button", {
						key: 1,
						type: "button",
						class: normalizeClass(["v-legend__button", { "v-legend__button--unselected": !selectedIds.value.has(item.label) }]),
						onClick: ($event) => toggleItem(item)
					}, [createElementVNode("div", _hoisted_11, [item.symbolUrl ? (openBlock(), createElementBlock("img", {
						key: 0,
						src: item.symbolUrl
					}, null, 8, _hoisted_12)) : (openBlock(), createElementBlock("svg", _hoisted_13, [createElementVNode("rect", { style: normalizeStyle(item.style) }, null, 4)]))]), createElementVNode("span", { innerHTML: getItemLabel(item) }, null, 8, _hoisted_14)], 10, _hoisted_10)) : createCommentVNode("", true)], 10, _hoisted_5$2);
				}), 256)), group.items.length == 0 ? (openBlock(), createElementBlock("div", _hoisted_15, " Keine Einträge ")) : createCommentVNode("", true)], 64)) : createCommentVNode("", true)])]);
			}), 256)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createTextVNode(" Keine Legendeninformationen vorhanden ")], 64))]);
		};
	}
});
//#endregion
//#region src/components/SvgColorGradient.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$24 = {
	class: "v-svg-color-gradient__svg",
	preserveAspectRatio: "none",
	xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_2$16 = [
	"id",
	"x1",
	"y1",
	"x2",
	"y2"
];
var _hoisted_3$13 = ["offset", "stop-color"];
var _hoisted_4$12 = ["fill"];
//#endregion
//#region src/components/SvgColorGradient.vue
var SvgColorGradient_default = /* @__PURE__ */ defineComponent({
	__name: "SvgColorGradient",
	props: { config: {} },
	setup(__props) {
		const props = __props;
		const fallbackId = useId();
		const gradientId = computed(() => `svg-gradient-${fallbackId}`);
		const isVertical = computed(() => props.config.orientation === "vertical");
		const verticalClass = computed(() => ({ "v-svg-color-gradient--vertical": isVertical.value }));
		const x1 = computed(() => isVertical.value ? "0" : "0");
		const y1 = computed(() => isVertical.value ? "0" : "0");
		const x2 = computed(() => isVertical.value ? "0" : "1");
		const y2 = computed(() => isVertical.value ? "1" : "0");
		const gradientStops = computed(() => {
			const colors = props.config.colors;
			const stops = props.config.stops;
			const count = colors.length;
			if (count === 0) return [];
			return colors.map((color, index) => {
				let offset;
				if (stops && stops.length > index && stops[index] !== void 0) offset = `${Math.max(0, Math.min(1, stops[index]))}`;
				else if (count === 1) offset = "0";
				else offset = `${index / (count - 1)}`;
				return {
					offset,
					color
				};
			});
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["v-svg-color-gradient", verticalClass.value]) }, [(openBlock(), createElementBlock("svg", _hoisted_1$24, [createElementVNode("defs", null, [createElementVNode("linearGradient", {
				id: gradientId.value,
				x1: x1.value,
				y1: y1.value,
				x2: x2.value,
				y2: y2.value
			}, [(openBlock(true), createElementBlock(Fragment, null, renderList(gradientStops.value, (stop, index) => {
				return openBlock(), createElementBlock("stop", {
					key: index,
					offset: stop.offset,
					"stop-color": stop.color
				}, null, 8, _hoisted_3$13);
			}), 128))], 8, _hoisted_2$16)]), createElementVNode("rect", {
				x: "0",
				y: "0",
				width: "100%",
				height: "100%",
				fill: `url(#${gradientId.value})`
			}, null, 8, _hoisted_4$12)]))], 2);
		};
	}
});
//#endregion
//#region src/components/collapsible/Collapsible.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$23 = {
	key: 0,
	class: "v-collapsible__body"
};
//#endregion
//#region src/components/collapsible/Collapsible.vue
var Collapsible_default = /* @__PURE__ */ defineComponent({
	__name: "Collapsible",
	props: {
		header: { default: "Aufklappbereich" },
		collapsed: {
			type: Boolean,
			default: true
		},
		toggleGroupId: {}
	},
	setup(__props) {
		const props = __props;
		const collapsed = ref(props.collapsed);
		const dynamicClass = computed(() => {
			return {
				"v-collapsible": true,
				"v-collapsible--collapsed": collapsed.value,
				"v-collapsible--uncollapsed": !collapsed.value
			};
		});
		function toggle(evt) {
			collapsed.value = !collapsed.value;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(dynamicClass.value) }, [createElementVNode("button", {
				class: "v-collapsible__header",
				onClick: toggle
			}, [renderSlot(_ctx.$slots, "header", { toggle }, () => [createTextVNode(toDisplayString(props.header), 1)])]), !collapsed.value ? (openBlock(), createElementBlock("div", _hoisted_1$23, [renderSlot(_ctx.$slots, "default", {}, () => [_cache[0] || (_cache[0] = createTextVNode(" [ Text im Aufklappbereich ] ", -1))])])) : createCommentVNode("", true)], 2);
		};
	}
});
//#endregion
//#region src/SelectMode.ts
var SelectMode = /* @__PURE__ */ function(SelectMode) {
	SelectMode["None"] = "none";
	SelectMode["Single"] = "single";
	SelectMode["SingleArray"] = "single-array";
	SelectMode["Multi"] = "multi";
	return SelectMode;
}({});
//#endregion
//#region src/util/miscUtils.ts
function debounce(func, delay_ms) {
	let timeout = -1;
	const debouncedFunc = (...args) => {
		if (timeout === -1) {
			func(...args);
			timeout = window.setTimeout(() => {
				clearTimeout(timeout);
				timeout = -1;
			}, delay_ms);
			return;
		}
		clearTimeout(timeout);
		const later = () => {
			clearTimeout(timeout);
			timeout = -1;
			func(...args);
		};
		timeout = window.setTimeout(later, delay_ms);
	};
	return debouncedFunc;
}
function getDocumentScrollbarWidth() {
	return window.innerWidth - document.documentElement.clientWidth;
}
function makeArray(a) {
	if (a === null || a === void 0) return [];
	return a instanceof Array ? a : [a];
}
function roundToDigits(value, digits) {
	const multiplier = Math.pow(10, digits);
	return Math.round(value * multiplier) / multiplier;
}
//#endregion
//#region src/util/selectionHelperFunctions.ts
/**
* 
* @param previouslySelectedArray The list of previously selected items
* @param newlySelected      The item that should be selected or unselected
* @param selectMode         The selection mode that should be applied (see {@link SelectMode})
* @param allowUnselect      Whether the item should be unselected if it is already selected
* @returns The new list of selected items, or the newly selected item if the select mode is {@link SelectMode.Single}
* 
* This function implements the selection logic for components that display a list of items and allow
* the user to select (and possibly unselect) items. 
* 
* The selection logic is determined by the `selectMode` parameter, which can be one of the following:
* 
* - `SelectMode.None`: No selection is allowed. 
* - `SelectMode.Single`: Only one item can be selected at a time. 
* - `SelectMode.SingleArray`: Similar to `SelectMode.Single`, 
*    but the function will always return an array of selected items, even if there is only one selected item.
* 
* - `SelectMode.Multi`: Multiple items can be selected. 
* 
* If `allowUnselect` is `true`, and `newlySelectet` is an item that is already in the list of selected items, then
* the item will be removed from the list of selected items. If select mode is `SelectMode.Single`, the function
* returns `null` in this case.
*/
function handleSelection(previouslySelected, newlySelected, selectMode, allowUnselect, compareFunc) {
	let result = [...makeArray(previouslySelected)];
	let index = -1;
	for (let ii = 0; ii < result.length; ii++) if (compareFunc(result[ii]) == compareFunc(newlySelected)) {
		index = ii;
		break;
	}
	if (index >= 0 && allowUnselect) result.splice(index, 1);
	else switch (selectMode) {
		case SelectMode.None: break;
		case SelectMode.Single:
		case SelectMode.SingleArray:
			result = [newlySelected];
			break;
		case SelectMode.Multi: if (index == -1) result.push(newlySelected);
	}
	if (selectMode == SelectMode.Single) return result.length > 0 ? result[0] : null;
	return result;
}
//#endregion
//#region src/components/HeadlessList.vue
var HeadlessList_default = /* @__PURE__ */ defineComponent({
	__name: "HeadlessList",
	props: {
		allowUnselect: {
			type: Boolean,
			default: true
		},
		hover: {},
		items: { default: () => [] },
		compareFunc: {
			type: Function,
			default: (item) => item
		},
		selected: {},
		selectMode: { default: SelectMode.None }
	},
	emits: [
		"update:hover",
		"update:selected",
		"update:items"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		function onItemClick(item) {
			const result = handleSelection(props.selected, item, props.selectMode, props.allowUnselect, props.compareFunc);
			emit("update:selected", result);
		}
		function isHover(item) {
			return props.hover === item;
		}
		function isSelected(item) {
			const selected = makeArray(props.selected);
			if (selected.includes(item)) return true;
			if (props.compareFunc) {
				const itemCompareValue = props.compareFunc(item);
				for (const i of selected) if (props.compareFunc(i) == itemCompareValue) return true;
			}
			return false;
		}
		return (_ctx, _cache) => {
			return openBlock(true), createElementBlock(Fragment, null, renderList(props.items, (item, index) => {
				return renderSlot(_ctx.$slots, "default", {
					key: index,
					item,
					index,
					isSelected: isSelected(item),
					isHover: isHover(item),
					onItemClick
				});
			}), 128);
		};
	}
});
//#endregion
//#region src/components/Combobox.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$22 = { class: "v-combobox" };
var _hoisted_2$15 = ["placeholder"];
var _hoisted_3$12 = { class: "v-combobox__panel" };
var _hoisted_4$11 = ["onClick"];
//#endregion
//#region src/components/Combobox.vue
var Combobox_default = /* @__PURE__ */ defineComponent({
	__name: "Combobox",
	props: {
		items: { default: () => [] },
		modelValue: { default: null },
		placeholder: { default: "" },
		filterFunc: {
			type: [Function, null],
			default: null
		},
		displayFunc: {
			type: Function,
			default: (item) => String(item)
		}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const filterText = ref("");
		const isOpen = ref(false);
		const filteredItems = computed(() => {
			const text = filterText.value;
			if (!text) return props.items;
			if (props.filterFunc) return props.items.filter((item) => props.filterFunc(item, text));
			return props.items.filter((item) => String(item).toLowerCase().includes(text.toLowerCase()));
		});
		function onFocus() {
			filterText.value = "";
			isOpen.value = true;
		}
		function onBlur() {
			isOpen.value = false;
			filterText.value = "";
		}
		function selectItem(item) {
			emit("update:modelValue", item);
			filterText.value = "";
			isOpen.value = false;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$22, [withDirectives(createElementVNode("input", {
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => filterText.value = $event),
				type: "text",
				class: "v-combobox__input",
				placeholder: __props.placeholder,
				onFocus,
				onClick: _cache[1] || (_cache[1] = ($event) => isOpen.value = true),
				onBlur
			}, null, 40, _hoisted_2$15), [[vModelText, filterText.value]]), withDirectives(createElementVNode("div", _hoisted_3$12, [createVNode(HeadlessList_default, {
				items: filteredItems.value,
				"select-mode": unref(SelectMode).None
			}, {
				default: withCtx(({ item }) => [createElementVNode("div", {
					class: "v-combobox__item",
					onMousedown: _cache[2] || (_cache[2] = withModifiers(() => {}, ["prevent"])),
					onClick: ($event) => selectItem(item)
				}, [renderSlot(_ctx.$slots, "item", { item }, () => [createTextVNode(toDisplayString(item), 1)])], 40, _hoisted_4$11)]),
				_: 3
			}, 8, ["items", "select-mode"])], 512), [[vShow, isOpen.value]])]);
		};
	}
});
//#endregion
//#region src/util/urlParamsUtils.ts
function readUrlParams() {
	const url_params = {};
	const params = new URL(window.location.href).searchParams;
	const keys = Array();
	params.forEach((value, key) => {
		keys.push(key);
	});
	for (const key of keys) {
		const param = params.get(key);
		if (param == null) continue;
		let value;
		try {
			value = JSON.parse(param);
		} catch (e) {
			try {
				value = JSON.parse("\"" + param + "\"");
			} catch (e) {
				value = param;
			}
		}
		if (value != "") url_params[key] = value;
		else delete url_params[key];
	}
	return url_params;
}
function updateBrowserUrl(params) {
	const url = new URL(window.location.href);
	for (const key in params) if (params[key] !== void 0) url.searchParams.set(key, params[key]);
	else url.searchParams.delete(key);
	history.replaceState(void 0, "", url.toString());
}
//#endregion
//#region src/components/DashboardPanel.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$21 = ["id"];
var _hoisted_2$14 = { class: "v-dashboard-panel__header" };
var _hoisted_3$11 = { class: "v-dashboard-panel__header-left" };
var _hoisted_4$10 = { class: "v-dashboard-panel__body" };
//#endregion
//#region src/components/DashboardPanel.vue
var DashboardPanel_default = /* @__PURE__ */ defineComponent({
	__name: "DashboardPanel",
	props: {
		fullWindow: {
			type: Boolean,
			default: false
		},
		id: {},
		showFullscreenButton: {
			type: Boolean,
			default: false
		},
		urlParamFullscreen: { default: "fullscreenPanel" }
	},
	setup(__props) {
		const props = __props;
		const customButtonsArea = ref(null);
		const fullWindowBackend = ref(props.fullWindow);
		const sfb = computed(() => {
			return props.showFullscreenButton || fullWindow.value;
		});
		const fullWindow = computed({
			get() {
				return fullWindowBackend.value;
			},
			set(newval) {
				fullWindowBackend.value = newval;
				if (fullWindowBackend.value) updateBrowserUrl({ [props.urlParamFullscreen]: props.id });
				else updateBrowserUrl({ [props.urlParamFullscreen]: void 0 });
			}
		});
		provide("externalToolbar", customButtonsArea);
		onMounted(() => {
			const urlParams = readUrlParams();
			if (urlParams?.fullscreenPanel && urlParams?.[props.urlParamFullscreen] == props.id) fullWindow.value = true;
		});
		function getFullscreenButtonTooltip() {
			return fullWindow.value ? "Vollbildmodus beenden" : "Panel auf Vollbild vergrößern";
		}
		return (_ctx, _cache) => {
			const _directive_full_window = resolveDirective("full-window");
			return withDirectives((openBlock(), createElementBlock("div", {
				id: props.id,
				class: "v-dashboard-panel"
			}, [createElementVNode("div", _hoisted_2$14, [createElementVNode("div", _hoisted_3$11, [renderSlot(_ctx.$slots, "header-left")]), createElementVNode("div", {
				ref_key: "customButtonsArea",
				ref: customButtonsArea,
				class: "v-dashboard-panel__header-right"
			}, [sfb.value ? (openBlock(), createBlock(SmartButton_default, {
				key: 0,
				modelValue: fullWindow.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => fullWindow.value = $event),
				set: true,
				unset: false,
				"data-tooltip": getFullscreenButtonTooltip()
			}, {
				default: withCtx(() => [..._cache[1] || (_cache[1] = [createElementVNode("img", { src: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='iso-8859-1'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2016.0.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3c!DOCTYPE%20svg%20PUBLIC%20'-//W3C//DTD%20SVG%201.1//EN'%20'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg%20version='1.1'%20id='Capa_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20width='402.996px'%20height='402.996px'%20viewBox='0%200%20402.996%20402.996'%20style='enable-background:new%200%200%20402.996%20402.996;'%20xml:space='preserve'%3e%3cg%3e%3cg%3e%3cpath%20d='M392.996,1.985H258.33c-5.523,0-10,4.477-10,10V31.01c0,5.523,4.477,10,10,10h78.046L224.955,152.431%20c-3.905,3.905-3.905,10.237,0,14.142l13.453,13.453c1.953,1.953,4.512,2.929,7.07,2.929c2.56,0,5.119-0.977,7.071-2.929%20L363.972,68.604v78.047c0,5.523,4.478,10,10,10h19.024c5.523,0,10-4.477,10-10V11.985C402.996,6.462,398.52,1.985,392.996,1.985z'%20/%3e%3cpath%20d='M66.62,41.01h78.046c5.523,0,10-4.477,10-10V11.985c0-5.523-4.477-10-10-10H10c-5.523,0-10,4.477-10,10v134.666%20c0,5.523,4.477,10,10,10h19.024c5.523,0,10-4.477,10-10V68.604l111.422,111.421c1.952,1.953,4.512,2.929,7.071,2.929%20s5.119-0.977,7.071-2.929l13.453-13.453c3.905-3.905,3.905-10.237,0-14.142L66.62,41.01z'/%3e%3cpath%20d='M392.996,246.344h-19.024c-5.522,0-10,4.478-10,10v78.047L252.55,222.97c-3.903-3.905-10.237-3.905-14.142,0%20l-13.453,13.453c-3.905,3.904-3.905,10.236,0,14.142l111.421,111.421H258.33c-5.523,0-10,4.477-10,10v19.023%20c0,5.523,4.477,10,10,10h134.666c5.523,0,10-4.477,10-10V256.344C402.996,250.821,398.52,246.344,392.996,246.344z'/%3e%3cpath%20d='M164.588,222.97c-3.905-3.905-10.238-3.905-14.142,0L39.024,334.392v-78.047c0-5.523-4.477-10-10-10H10%20c-5.523,0-10,4.477-10,10v134.666c0,5.523,4.477,10,10,10h134.666c5.523,0,10-4.477,10-10v-19.023c0-5.523-4.477-10-10-10H66.62%20l111.421-111.422c3.905-3.904,3.905-10.236,0-14.143L164.588,222.97z'/%3e%3c/g%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3c/svg%3e" }, null, -1)])]),
				_: 1
			}, 8, ["modelValue", "data-tooltip"])) : createCommentVNode("", true), renderSlot(_ctx.$slots, "header-right")], 512)]), createElementVNode("div", _hoisted_4$10, [renderSlot(_ctx.$slots, "default")])], 8, _hoisted_1$21)), [[_directive_full_window, fullWindow.value]]);
		};
	}
});
//#endregion
//#region src/components/dualView/DualViewSyncModule.ts
var activeDualViewId = ref(null);
//#endregion
//#region src/composables/useViewportSize.ts
function useViewportSize() {
	const size = ref(new Vector2(window.innerWidth, window.innerHeight));
	onMounted(() => {
		window.addEventListener("resize", onResize);
	});
	onBeforeUnmount(() => {
		window.removeEventListener("resize", onResize);
	});
	function onResize() {
		size.value = new Vector2(window.innerWidth, window.innerHeight);
	}
	return size;
}
//#endregion
//#region src/composables/useDragPosition.ts
function useDragPosition(target) {
	const pos = ref(new Vector2());
	const isDragging = ref(false);
	function onMouseDown(evt) {
		isDragging.value = true;
	}
	function onMouseMove(evt) {
		if (!isDragging.value) return;
		pos.value = new Vector2(evt.clientX, evt.clientY);
	}
	function onMouseUp(evt) {
		isDragging.value = false;
	}
	function onTouchEnd(evt) {
		isDragging.value = false;
	}
	function onTouchMove(evt) {
		if (!isDragging.value) return;
		const touch1 = evt.touches[0];
		pos.value = new Vector2(touch1.clientX, touch1.clientY);
	}
	function onTouchStart(evt) {
		isDragging.value = true;
	}
	useEventListener(target, "mousedown", onMouseDown);
	useEventListener(target, "touchstart", onTouchStart);
	useEventListener(document, "mousemove", onMouseMove);
	useEventListener(document, "mouseup", onMouseUp);
	useEventListener(document, "touchend", onTouchEnd);
	useEventListener(document, "touchmove", onTouchMove);
	return {
		pos,
		isDragging
	};
}
//#endregion
//#region src/components/dualView/DualView.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$20 = {
	key: 0,
	class: "v-dual-view__hint"
};
var _hoisted_2$13 = { class: "v-dual-view__panel__content" };
//#endregion
//#region src/components/dualView/DualView.vue
var DualView_default = /* @__PURE__ */ defineComponent({
	__name: "DualView",
	props: {
		allowClose: {
			type: Boolean,
			default: true
		},
		enabled: {
			type: Boolean,
			default: false
		},
		panelOnRight: {
			type: Boolean,
			default: false
		},
		ratio: { default: 50 },
		showHint: {
			type: Boolean,
			default: true
		}
	},
	emits: ["update:enabled"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const ratio = ref(props.ratio);
		watch(() => props.ratio, (newVal) => {
			ratio.value = newVal;
			updateSizes();
		});
		const drag_handle_h = ref(null);
		const drag_handle_v = ref(null);
		const { pos: dragPosH } = useDragPosition(drag_handle_h);
		const { pos: dragPosV } = useDragPosition(drag_handle_v);
		const viewportSize = useViewportSize();
		const myId = uuid.v4();
		const appElem = document.getElementById("app");
		if (appElem == null) console.error("DualView: No app element found!");
		const emit = __emit;
		const cssClass = computed(() => {
			return {
				"v-dual-view": true,
				"v-dual-view--enabled": props.enabled,
				"v-dual-view--disabled": !props.enabled
			};
		});
		const panelStyle = computed(() => {
			const result = {};
			if (props.enabled) if (viewportSize.value.x > viewportSize.value.y) {
				if (!props.panelOnRight) result.left = "0%";
				else result.left = `${ratio.value}%`;
				result.width = `${100 - ratio.value}%`;
			} else result.bottom = `${ratio.value}%`;
			return result;
		});
		function onCloseButtonClick() {
			activeDualViewId.value = null;
			resetAppElemStyles();
			emit("update:enabled", false);
		}
		function updateSizes() {
			if (!appElem) return;
			if (viewportSize.value.x > viewportSize.value.y) {
				if (!props.panelOnRight) appElem.style.left = `${100 - ratio.value}%`;
				else appElem.style.removeProperty("left");
				appElem.style.top = "0";
				appElem.style.bottom = "0";
				appElem.style.width = `${ratio.value}%`;
			} else {
				appElem.style.top = `${100 - ratio.value}%`;
				appElem.style.removeProperty("left");
			}
		}
		function resetAppElemStyles() {
			if (!appElem) return;
			appElem.classList.remove("v-dual-view-enabled-app");
			appElem.style.removeProperty("left");
			appElem.style.removeProperty("width");
			appElem.style.removeProperty("top");
			appElem.style.removeProperty("bottom");
		}
		function updateClasses() {
			if (!appElem) return;
			updateSizes();
			if (props.enabled) {
				activeDualViewId.value = myId;
				appElem.classList.add("v-dual-view-enabled-app");
				if (viewportSize.value.x > viewportSize.value.y) appElem.style.removeProperty("top");
				else appElem.style.removeProperty("width");
			} else if (activeDualViewId.value == null || activeDualViewId.value == myId) resetAppElemStyles();
		}
		watch(() => activeDualViewId.value, () => {
			if (activeDualViewId.value == myId) return;
			emit("update:enabled", false);
		});
		watch(() => [props.enabled, viewportSize.value], () => {
			updateClasses();
		}, { immediate: true });
		watch(() => dragPosH.value, () => {
			let newRatio = Math.round(dragPosH.value.x / window.innerWidth * 100);
			if (!props.panelOnRight) newRatio = 100 - newRatio;
			newRatio = Math.max(newRatio, 0);
			newRatio = Math.min(newRatio, 100);
			ratio.value = newRatio;
			updateSizes();
		});
		watch(() => dragPosV.value, () => {
			let newRatio = Math.round(dragPosV.value.y / window.innerHeight * 100);
			newRatio = Math.max(newRatio, 0);
			newRatio = Math.min(newRatio, 100);
			ratio.value = 100 - newRatio;
			updateSizes();
		});
		onMounted(() => {
			updateSizes();
			window.addEventListener("resize", updateSizes);
		});
		onBeforeUnmount(() => {
			onCloseButtonClick();
			window.removeEventListener("resize", updateSizes);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(cssClass.value) }, [props.enabled && props.showHint ? (openBlock(), createElementBlock("div", _hoisted_1$20, [_cache[0] || (_cache[0] = createElementVNode("span", null, "Das Element an dieser Stelle wird im Moment als geteilte Ansicht dargestellt.", -1)), props.allowClose ? (openBlock(), createElementBlock("button", {
				key: 0,
				onClick: onCloseButtonClick
			}, " Geteilte Ansicht beenden ")) : createCommentVNode("", true)])) : createCommentVNode("", true), createElementVNode("div", {
				class: "v-dual-view__panel",
				style: normalizeStyle(panelStyle.value)
			}, [createElementVNode("div", _hoisted_2$13, [renderSlot(_ctx.$slots, "default")]), props.enabled ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
				props.allowClose ? (openBlock(), createElementBlock("button", {
					key: 0,
					"data-tooltip": "Geteilte Ansicht beenden",
					class: "v-dual-view__close-button",
					onClick: onCloseButtonClick
				}, [..._cache[1] || (_cache[1] = [createElementVNode("img", { src: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3csvg%20xmlns:dc='http://purl.org/dc/elements/1.1/'%20xmlns:cc='http://creativecommons.org/ns%23'%20xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%20xmlns:svg='http://www.w3.org/2000/svg'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20version='1.1'%20id='Layer_1'%20x='0px'%20y='0px'%20viewBox='0%200%201792%201792'%20style='enable-background:new%200%200%201792%201792;'%20xml:space='preserve'%20sodipodi:docname='cross-white.svg'%20inkscape:version='0.92.5%20(2060ec1f9f,%202020-04-08)'%3e%3cmetadata%20id='metadata9'%3e%3crdf:RDF%3e%3ccc:Work%20rdf:about=''%3e%3cdc:format%3eimage/svg+xml%3c/dc:format%3e%3cdc:type%20rdf:resource='http://purl.org/dc/dcmitype/StillImage'%20/%3e%3cdc:title%3e%3c/dc:title%3e%3c/cc:Work%3e%3c/rdf:RDF%3e%3c/metadata%3e%3cdefs%20id='defs7'%20/%3e%3csodipodi:namedview%20pagecolor='%23ffffff'%20bordercolor='%23666666'%20borderopacity='1'%20objecttolerance='10'%20gridtolerance='10'%20guidetolerance='10'%20inkscape:pageopacity='0'%20inkscape:pageshadow='2'%20inkscape:window-width='999'%20inkscape:window-height='480'%20id='namedview5'%20showgrid='false'%20inkscape:zoom='0.13169643'%20inkscape:cx='896'%20inkscape:cy='896'%20inkscape:window-x='0'%20inkscape:window-y='0'%20inkscape:window-maximized='0'%20inkscape:current-layer='Layer_1'%20/%3e%3cpath%20d='M1082.2,896.6l410.2-410c51.5-51.5,51.5-134.6,0-186.1s-134.6-51.5-186.1,0l-410.2,410L486,300.4%20c-51.5-51.5-134.6-51.5-186.1,0s-51.5,134.6,0,186.1l410.2,410l-410.2,410c-51.5,51.5-51.5,134.6,0,186.1%20c51.6,51.5,135,51.5,186.1,0l410.2-410l410.2,410c51.5,51.5,134.6,51.5,186.1,0c51.1-51.5,51.1-134.6-0.5-186.2L1082.2,896.6z'%20id='path2'%20style='fill:%23ffffff'%20/%3e%3c/svg%3e" }, null, -1)])])) : createCommentVNode("", true),
				withDirectives(createElementVNode("div", {
					ref_key: "drag_handle_h",
					ref: drag_handle_h,
					tabindex: "-1",
					class: normalizeClass(`v-dual-view__handle v-dual-view__handle_h ${props.panelOnRight ? "x-right" : "x-left"}`),
					draggable: "false",
					"data-tooltip": "Hier ziehen, um die geteilte Ansicht zu skalieren"
				}, null, 2), [[vShow, unref(viewportSize).x > unref(viewportSize).y]]),
				withDirectives(createElementVNode("div", {
					ref_key: "drag_handle_v",
					ref: drag_handle_v,
					tabindex: "-1",
					class: "v-dual-view__handle v-dual-view__handle_v",
					draggable: "false",
					"data-tooltip": "Hier ziehen, um die geteilte Ansicht zu skalieren"
				}, null, 512), [[vShow, unref(viewportSize).x < unref(viewportSize).y]])
			], 64)) : createCommentVNode("", true)], 4)], 2);
		};
	}
});
//#endregion
//#region src/components/HighlightText.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$19 = ["innerHTML"];
//#endregion
//#region src/components/HighlightText.vue
var HighlightText_default = /* @__PURE__ */ defineComponent({
	__name: "HighlightText",
	props: {
		highlight: { default: "" },
		text: { default: "" },
		caseSensitive: {
			type: Boolean,
			default: false
		}
	},
	setup(__props) {
		const props = __props;
		let text_lc, highlight_lc;
		const content = computed(() => {
			let t = props.text;
			if (props.highlight == "") return t;
			let offset = 0;
			while (true) {
				const pos = text_lc.indexOf(highlight_lc, offset);
				if (pos == -1) break;
				const replace = "<span>" + t.substring(pos, pos + highlight_lc.length) + "</span>";
				t = t.substring(0, pos) + replace + t.substring(pos + highlight_lc.length);
				offset = pos + replace.length + 1;
			}
			return t;
		});
		watch(() => props.highlight, () => {
			highlight_lc = props.highlight.toLocaleLowerCase();
		}, { immediate: true });
		watch(() => props.text, () => {
			text_lc = props.text.toLocaleLowerCase();
		}, { immediate: true });
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("span", {
				class: "v-highlight-text",
				innerHTML: content.value
			}, null, 8, _hoisted_1$19);
		};
	}
});
//#endregion
//#region src/components/List.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$18 = {
	class: "v-list",
	role: "list"
};
var _hoisted_2$12 = [
	"data-tooltip",
	"onMouseover",
	"onClick"
];
var _hoisted_3$10 = { style: { "flex": "1" } };
var _hoisted_4$9 = ["onClick"];
//#endregion
//#region src/components/List.vue
var List_default = /* @__PURE__ */ defineComponent({
	__name: "List",
	props: {
		allowUnselect: {
			type: Boolean,
			default: true
		},
		hover: {},
		items: { default: () => [] },
		compareFunc: {},
		liStyleFunc: {},
		onClick: {
			type: Function,
			default: () => {}
		},
		onRemoveButtonClick: {},
		removeButtons: {
			type: Boolean,
			default: false
		},
		selected: { default: null },
		selectMode: { default: SelectMode.Single },
		tooltipFunc: {
			type: Function,
			default: () => ""
		}
	},
	emits: [
		"update:hover",
		"update:selected",
		"update:items"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const hoverItem = computed(() => makeArray(props.hover)[0] ?? null);
		function getDynamicClasses(item, isSelected, isHover) {
			return {
				"v-list__item": true,
				"x-hover": isHover,
				"x-selected": isSelected,
				"x-no-unselect": isSelected && !props.allowUnselect
			};
		}
		function getTooltipText(item) {
			const f = props.tooltipFunc;
			if (typeof f == "function") return f(item);
			return "";
		}
		function handleItemClick(item, headlessOnItemClick) {
			props.onClick(item);
			headlessOnItemClick(item);
		}
		function handleRemoveButtonClick(item, e) {
			e.stopPropagation();
			if (props.onRemoveButtonClick) {
				props.onRemoveButtonClick(item);
				return;
			}
			const items_cloned = makeArray(props.items);
			const index = items_cloned.indexOf(item);
			items_cloned.splice(index, 1);
			emit("update:items", items_cloned);
		}
		function onItemKeyDown(evt) {
			const target = evt.currentTarget;
			if (!target) return;
			let next;
			switch (evt.key) {
				case "ArrowUp":
				case "ArrowLeft":
					next = target.previousElementSibling;
					break;
				case "ArrowDown":
				case "ArrowRight":
					next = target.nextElementSibling;
					break;
			}
			if (next) {
				const button = next.firstElementChild?.firstElementChild;
				if (button) {
					button.focus();
					evt.preventDefault();
				}
			}
		}
		function onItemMouseOver(item) {
			emit("update:hover", item);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("ul", _hoisted_1$18, [createVNode(HeadlessList_default, {
				items: props.items,
				selected: props.selected,
				hover: hoverItem.value,
				"compare-func": props.compareFunc,
				"allow-unselect": props.allowUnselect,
				"select-mode": props.selectMode,
				"onUpdate:selected": _cache[0] || (_cache[0] = ($event) => emit("update:selected", $event))
			}, {
				default: withCtx(({ item, isSelected, isHover, onItemClick: headlessOnItemClick }) => [createElementVNode("li", {
					class: normalizeClass(getDynamicClasses(item, isSelected, isHover)),
					style: normalizeStyle(props.liStyleFunc ? props.liStyleFunc(item) : ""),
					"data-tooltip": getTooltipText(item),
					onMouseover: ($event) => onItemMouseOver(item),
					onKeydown: onItemKeyDown,
					onClick: ($event) => handleItemClick(item, headlessOnItemClick)
				}, [createElementVNode("div", null, [createElementVNode("button", _hoisted_3$10, [renderSlot(_ctx.$slots, "item", { item }, () => [createTextVNode(toDisplayString(item), 1)])]), props.removeButtons ? (openBlock(), createElementBlock("button", {
					key: 0,
					class: "v-list-item-remove-button",
					"data-tooltip": "Entfernen",
					"aria-label": "Entfernen",
					onClick: ($event) => handleRemoveButtonClick(item, $event)
				}, null, 8, _hoisted_4$9)) : createCommentVNode("", true)])], 46, _hoisted_2$12)]),
				_: 3
			}, 8, [
				"items",
				"selected",
				"hover",
				"compare-func",
				"allow-unselect",
				"select-mode"
			])]);
		};
	}
});
//#endregion
//#region src/components/Spinner.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$17 = { class: "v-spinner" };
//#endregion
//#region src/components/Spinner.vue
var Spinner_default = /* @__PURE__ */ defineComponent({
	__name: "Spinner",
	props: {
		color: { default: "#66f" },
		thickness: { default: "8px" }
	},
	setup(__props) {
		const props = __props;
		function getStyle() {
			const p = props.thickness;
			return `background:
        radial-gradient(farthest-side, ${props.color} 94%, #0000) top/${p} ${p} no-repeat,
        conic-gradient(#0000 30%, ${props.color});

    -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - ${p}), #000 0);`;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$17, [createElementVNode("div", {
				class: "v-spinner__animation",
				style: normalizeStyle(getStyle())
			}, null, 4)]);
		};
	}
});
//#endregion
//#region src/components/LoadingIndicatorOverlay.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$16 = { class: "v-loading-indicator-overlay" };
//#endregion
//#region src/components/LoadingIndicatorOverlay.vue
var LoadingIndicatorOverlay_default = /* @__PURE__ */ defineComponent({
	__name: "LoadingIndicatorOverlay",
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$16, [createElementVNode("div", null, [createVNode(Spinner_default)]), _cache[0] || (_cache[0] = createElementVNode("div", null, "Lade Daten ...", -1))]);
		};
	}
});
//#endregion
//#region src/components/SmartSelect.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$15 = ["innerHTML"];
var _hoisted_2$11 = ["innerHTML"];
var _hoisted_3$9 = ["value"];
var _hoisted_4$8 = {
	key: 1,
	class: "v-smart-select",
	disabled: "true"
};
//#endregion
//#region src/components/SmartSelect.vue
var SmartSelect_default = /* @__PURE__ */ defineComponent({
	__name: "SmartSelect",
	props: {
		initiallySelectedIndex: {},
		labelFunc: {},
		modelValue: {},
		nullOption: {
			type: Boolean,
			default: false
		},
		options: { default: () => [] },
		orderByLabel: {
			type: Boolean,
			default: true
		},
		nullOptionLabel: { default: "- Keine Auswahl -" },
		valueFunc: {}
	},
	emits: ["change", "update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const options = computed({
			get() {
				const result = [...props.options];
				if (props.orderByLabel) {
					const f = props.labelFunc;
					if (typeof f == "function") {
						const sortFunc = (a, b) => {
							const aa = f(a);
							const bb = f(b);
							if (aa < bb) return -1;
							else if (aa > bb) return 1;
							return 0;
						};
						result.sort(sortFunc);
					} else result.sort();
				}
				return result;
			},
			set(newValue) {}
		});
		const value = computed({
			get() {
				for (const option of options.value) {
					const optionValue = getOptionValue(option);
					if (props.modelValue == optionValue) return props.modelValue;
					if (JSON.stringify(optionValue) == JSON.stringify(props.modelValue)) return props.modelValue;
				}
			},
			set(newValue) {
				emit("update:modelValue", newValue);
				emit("change", newValue);
			}
		});
		function getOptionLabel(option) {
			if (typeof props.labelFunc == "function") return props.labelFunc(option);
			return option;
		}
		function getOptionValue(option) {
			if (typeof props.valueFunc == "function") return props.valueFunc(option);
			return option;
		}
		return (_ctx, _cache) => {
			return options.value.length > 0 ? withDirectives((openBlock(), createElementBlock("select", {
				key: 0,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
				class: "v-smart-select"
			}, [
				createElementVNode("option", {
					hidden: "",
					value: void 0,
					innerHTML: props.nullOptionLabel
				}, null, 8, _hoisted_1$15),
				__props.nullOption ? (openBlock(), createElementBlock("option", {
					key: 0,
					value: null,
					class: "v-smart-select__null-option",
					innerHTML: props.nullOptionLabel
				}, null, 8, _hoisted_2$11)) : createCommentVNode("", true),
				(openBlock(true), createElementBlock(Fragment, null, renderList(options.value, (option) => {
					return openBlock(), createElementBlock("option", { value: getOptionValue(option) }, toDisplayString(getOptionLabel(option)), 9, _hoisted_3$9);
				}), 256))
			], 512)), [[vModelSelect, value.value]]) : (openBlock(), createElementBlock("select", _hoisted_4$8, [..._cache[1] || (_cache[1] = [createElementVNode("option", null, "Keine Option verfügbar", -1)])]));
		};
	}
});
//#endregion
//#region src/components/PaginationControl.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$14 = ["aria-label"];
var _hoisted_2$10 = {
	key: 0,
	class: "v-pagination-control__compact"
};
var _hoisted_3$8 = ["disabled"];
var _hoisted_4$7 = ["disabled"];
var _hoisted_5$1 = { key: 1 };
var _hoisted_6 = [
	"disabled",
	"aria-label",
	"aria-current",
	"onClick",
	"innerHTML"
];
//#endregion
//#region src/components/PaginationControl.vue
var PaginationControl_default = /* @__PURE__ */ defineComponent({
	__name: "PaginationControl",
	props: {
		label: { default: "Pagination" },
		totalItems: {},
		pageSize: {},
		currentPage: { default: 0 },
		mode: { default: "default" }
	},
	emits: ["update:currentPage"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const localCurrentPage = ref(props.currentPage);
		const totalPages = computed(() => {
			return Math.ceil(props.totalItems / props.pageSize);
		});
		const pageNumbers = computed(() => {
			const pages = [];
			for (let i = 0; i < totalPages.value; i++) pages.push(i);
			return pages;
		});
		const isFirstPage = computed(() => localCurrentPage.value === 0);
		const isLastPage = computed(() => localCurrentPage.value === totalPages.value - 1);
		const goToPage = (page) => {
			if (page < 0 || page >= totalPages.value) return;
			emit("update:currentPage", localCurrentPage.value);
		};
		const nextPage = () => {
			if (!isLastPage.value) emit("update:currentPage", localCurrentPage.value + 1);
		};
		const prevPage = () => {
			if (!isFirstPage.value) emit("update:currentPage", localCurrentPage.value - 1);
		};
		watch(() => localCurrentPage.value, (newPage) => {
			if (newPage < 0 || newPage >= totalPages.value) emit("update:currentPage", 0);
			else emit("update:currentPage", newPage);
		});
		watch(() => props.currentPage, (newPage) => {
			localCurrentPage.value = newPage;
		});
		watch(() => props.totalItems, (newTotal) => {
			if (Math.ceil(newTotal / props.pageSize) < localCurrentPage.value + 1) emit("update:currentPage", 0);
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("nav", {
				class: "v-pagination-control",
				"aria-label": props.label
			}, [props.mode == "compact" ? (openBlock(), createElementBlock("div", _hoisted_2$10, [
				createElementVNode("button", {
					disabled: isFirstPage.value,
					"aria-label": "Previous Page",
					onClick: prevPage
				}, [..._cache[1] || (_cache[1] = [createElementVNode("img", {
					style: { "transform": "rotate(180deg)" },
					src: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3csvg%20xmlns:dc='http://purl.org/dc/elements/1.1/'%20xmlns:cc='http://creativecommons.org/ns%23'%20xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%20xmlns:svg='http://www.w3.org/2000/svg'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20version='1.1'%20id='Layer_1'%20x='0px'%20y='0px'%20viewBox='0%200%20512%20512'%20enable-background='new%200%200%20512%20512'%20xml:space='preserve'%20sodipodi:docname='right-open.svg'%20inkscape:version='0.92.5%20(2060ec1f9f,%202020-04-08)'%3e%3cmetadata%20id='metadata9'%3e%3crdf:RDF%3e%3ccc:Work%20rdf:about=''%3e%3cdc:format%3eimage/svg+xml%3c/dc:format%3e%3cdc:type%20rdf:resource='http://purl.org/dc/dcmitype/StillImage'%20/%3e%3cdc:title%3e%3c/dc:title%3e%3c/cc:Work%3e%3c/rdf:RDF%3e%3c/metadata%3e%3cdefs%20id='defs7'%20/%3e%3csodipodi:namedview%20pagecolor='%23ffffff'%20bordercolor='%23666666'%20borderopacity='1'%20objecttolerance='10'%20gridtolerance='10'%20guidetolerance='10'%20inkscape:pageopacity='0'%20inkscape:pageshadow='2'%20inkscape:window-width='870'%20inkscape:window-height='480'%20id='namedview5'%20showgrid='false'%20inkscape:zoom='0.4609375'%20inkscape:cx='256'%20inkscape:cy='256'%20inkscape:window-x='0'%20inkscape:window-y='0'%20inkscape:window-maximized='0'%20inkscape:current-layer='Layer_1'%20/%3e%3cpolygon%20points='0,162.9%20256,418.9%20512,162.9%20442.2,93.1%20256,279.3%2069.8,93.1%20'%20id='polygon2'%20transform='rotate(-90,256,256)'%20/%3e%3c/svg%3e",
					alt: ""
				}, null, -1)])], 8, _hoisted_3$8),
				createVNode(SmartSelect_default, {
					"model-value": localCurrentPage.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => localCurrentPage.value = $event),
					label: "Select Page",
					options: pageNumbers.value,
					"label-func": (page) => page + 1 + "/" + totalPages.value,
					"order-by-label": false
				}, null, 8, [
					"model-value",
					"options",
					"label-func"
				]),
				createElementVNode("button", {
					disabled: isLastPage.value,
					"aria-label": "Next Page",
					onClick: nextPage
				}, [..._cache[2] || (_cache[2] = [createElementVNode("img", {
					src: "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'%20standalone='no'?%3e%3csvg%20xmlns:dc='http://purl.org/dc/elements/1.1/'%20xmlns:cc='http://creativecommons.org/ns%23'%20xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23'%20xmlns:svg='http://www.w3.org/2000/svg'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd'%20xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape'%20version='1.1'%20id='Layer_1'%20x='0px'%20y='0px'%20viewBox='0%200%20512%20512'%20enable-background='new%200%200%20512%20512'%20xml:space='preserve'%20sodipodi:docname='right-open.svg'%20inkscape:version='0.92.5%20(2060ec1f9f,%202020-04-08)'%3e%3cmetadata%20id='metadata9'%3e%3crdf:RDF%3e%3ccc:Work%20rdf:about=''%3e%3cdc:format%3eimage/svg+xml%3c/dc:format%3e%3cdc:type%20rdf:resource='http://purl.org/dc/dcmitype/StillImage'%20/%3e%3cdc:title%3e%3c/dc:title%3e%3c/cc:Work%3e%3c/rdf:RDF%3e%3c/metadata%3e%3cdefs%20id='defs7'%20/%3e%3csodipodi:namedview%20pagecolor='%23ffffff'%20bordercolor='%23666666'%20borderopacity='1'%20objecttolerance='10'%20gridtolerance='10'%20guidetolerance='10'%20inkscape:pageopacity='0'%20inkscape:pageshadow='2'%20inkscape:window-width='870'%20inkscape:window-height='480'%20id='namedview5'%20showgrid='false'%20inkscape:zoom='0.4609375'%20inkscape:cx='256'%20inkscape:cy='256'%20inkscape:window-x='0'%20inkscape:window-y='0'%20inkscape:window-maximized='0'%20inkscape:current-layer='Layer_1'%20/%3e%3cpolygon%20points='0,162.9%20256,418.9%20512,162.9%20442.2,93.1%20256,279.3%2069.8,93.1%20'%20id='polygon2'%20transform='rotate(-90,256,256)'%20/%3e%3c/svg%3e",
					alt: ""
				}, null, -1)])], 8, _hoisted_4$7)
			])) : createCommentVNode("", true), props.mode == "default" ? (openBlock(), createElementBlock("ul", _hoisted_5$1, [(openBlock(true), createElementBlock(Fragment, null, renderList(pageNumbers.value, (page) => {
				return openBlock(), createElementBlock("li", { key: page }, [createElementVNode("button", {
					class: normalizeClass({ active: page === __props.currentPage }),
					disabled: page === __props.currentPage,
					"aria-label": "Page " + (page + 1),
					"aria-current": page === __props.currentPage ? "page" : void 0,
					onClick: ($event) => goToPage(page),
					innerHTML: page + 1
				}, null, 10, _hoisted_6)]);
			}), 128))])) : createCommentVNode("", true)], 8, _hoisted_1$14);
		};
	}
});
//#endregion
//#region src/util/svgUtils.ts
function getClassForAngle(textAngle_deg) {
	const offset_deg = 25;
	let textAnchor = "";
	if (textAngle_deg > 360 - offset_deg || textAngle_deg <= offset_deg) textAnchor = "top";
	else if (textAngle_deg > offset_deg && textAngle_deg <= 180 - offset_deg) textAnchor = "right";
	else if (textAngle_deg > 180 - offset_deg && textAngle_deg <= 205) textAnchor = "bottom";
	else if (textAngle_deg > 205 && textAngle_deg <= 360 - offset_deg) textAnchor = "left";
	return textAnchor;
}
function makeArcPath(start_deg, end_deg, radius_inner, radius_outer) {
	if (isNaN(start_deg)) return "";
	if (start_deg == end_deg) return "";
	const halfway_deg = start_deg + (end_deg - start_deg) / 2;
	const start_outer_px = polarToCartesian(radius_outer, start_deg);
	const start_inner_px = polarToCartesian(radius_inner, start_deg);
	const halfway_outer_px = polarToCartesian(radius_outer, halfway_deg);
	const halfway_inner_px = polarToCartesian(radius_inner, halfway_deg);
	const end_outer_px = polarToCartesian(radius_outer, end_deg);
	const end_inner_px = polarToCartesian(radius_inner, end_deg);
	let path = `M ${start_inner_px.x} ${start_inner_px.y} `;
	path += ` A ${radius_inner} ${radius_inner} 0 0 1 ${halfway_inner_px.x} ${halfway_inner_px.y}`;
	path += ` A ${radius_inner} ${radius_inner} 0 0 1 ${end_inner_px.x} ${end_inner_px.y}`;
	path += ` L ${end_outer_px.x} ${end_outer_px.y}`;
	path += ` A ${radius_outer} ${radius_outer} 0 0 0 ${halfway_outer_px.x} ${halfway_outer_px.y}`;
	path += ` A ${radius_outer} ${radius_outer} 0 0 0 ${start_outer_px.x} ${start_outer_px.y}`;
	path += ` L ${start_inner_px.x} ${start_inner_px.y}`;
	return path;
}
function polarToCartesian(radius, angleInDegrees) {
	const angleInRadians = (angleInDegrees - 90) * Math.PI / 180;
	return new Vector2(radius * Math.cos(angleInRadians), radius * Math.sin(angleInRadians));
}
//#endregion
//#region src/components/pieChart/PieChart.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$13 = { class: "v-pie-chart__inner" };
var _hoisted_2$9 = ["d"];
var _hoisted_3$7 = { class: "v-pie-chart__sections" };
var _hoisted_4$6 = [
	"d",
	"data-tooltip",
	"onMouseover",
	"onMouseout",
	"onClick"
];
var _hoisted_5 = ["innerHTML"];
//#endregion
//#region src/components/pieChart/PieChart.vue
var PieChart_default = /* @__PURE__ */ defineComponent({
	__name: "PieChart",
	props: {
		animationSpeed: { default: 0 },
		data: { default: () => [] },
		degEnd: { default: 360 },
		degStart: { default: 0 },
		labelAlign: { default: "auto" },
		labelFunc: {
			type: Function,
			default: (section) => formatNumber(section.dataItem.partSize, { numDecimals: 1 })
		},
		defaultExtrusion: { default: 1 },
		tooltipFunc: {
			type: Function,
			default: (renderData) => {
				return renderData.dataItem.label + ": <strong>" + formatNumber(renderData.dataItem.partSize, { numDecimals: 1 }) + "</strong>";
			}
		},
		total: {}
	},
	emits: ["update:legend-data-out", "section-click"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const mouseoverSection = ref(null);
		const renderData = ref(Array());
		const svg = ref(null);
		const rootElement = ref(null);
		const emit = __emit;
		const viewboxSize = useElementSize(svg);
		let animationProgress = 0;
		let animationIntervalHandle = 0;
		const radiusInner = computed(() => {
			let result = 0;
			const style = rootComputedStyles.value;
			if (!style) return result;
			const str = style.getPropertyValue("--radius-inner");
			const parsedValue = parseFloat(str);
			if (isNaN(parsedValue)) return result;
			else result = parsedValue;
			return result;
		});
		const radiusOuter = computed(() => {
			let result = .8;
			const style = rootComputedStyles.value;
			if (!style) return result;
			const str = style.getPropertyValue("--radius-outer");
			const parsedValue = parseFloat(str);
			if (isNaN(parsedValue)) return result;
			else result = parsedValue;
			return result;
		});
		const radiusLabels = computed(() => {
			let result = radiusInner.value + (radiusOuter.value - radiusInner.value) / 2;
			const style = rootComputedStyles.value;
			if (!style) return result;
			const str = style.getPropertyValue("--radius-labels");
			const parsedValue = parseFloat(str);
			if (isNaN(parsedValue)) return result;
			else result = parsedValue;
			return result;
		});
		const rootComputedStyles = computed(() => {
			const rootElem = rootElement.value;
			if (!rootElem) {
				const div = document.createElement("div");
				return window.getComputedStyle(div);
			}
			return window.getComputedStyle(rootElem);
		});
		const total = computed(() => {
			let result = props.total;
			let sum = 0;
			for (const item of props.data) {
				if (isNaN(item.partSize)) continue;
				sum += item.partSize;
			}
			if (result == void 0 || result < sum) result = sum;
			return result;
		});
		function buildLegendData(renderData) {
			const result = Array();
			const group = {
				label: "",
				items: []
			};
			const computedStyle = rootComputedStyles.value;
			if (!computedStyle) return result;
			for (const entry of renderData) {
				const style = { fill: computedStyle.getPropertyValue(`--data-item-fill-color-${entry.index}`) };
				if (entry.dataItem.partSize <= 0) continue;
				group.items.push({
					label: entry.dataItem.label + " (" + props.labelFunc(entry) + ")",
					style,
					highlight: entry == mouseoverSection.value
				});
			}
			result.push(group);
			return result;
		}
		function getBackgroundPath(data) {
			const sum_deg = getSumDeg(data);
			if (props.degStart + sum_deg > props.degEnd) return "";
			return makeArcPath(props.degStart, props.degEnd, scale(radiusInner.value), scale(radiusOuter.value));
		}
		function getSectionClass(entry) {
			return {
				"v-pie-chart__section": true,
				"x-hover": mouseoverSection.value == entry
			};
		}
		function getSumDeg(data) {
			let sum_deg = 0;
			const range_deg = props.degEnd - props.degStart;
			for (let index = 0; index < data.length; index++) {
				const entry_value = data[index].partSize;
				if (typeof entry_value != "number") continue;
				const value_deg = entry_value / total.value * range_deg;
				sum_deg += value_deg;
			}
			return sum_deg;
		}
		function onMouseOverSection(section) {
			mouseoverSection.value = section;
		}
		function onMouseOutSection(section) {
			mouseoverSection.value = null;
		}
		function onSectionClick(section) {
			emit("section-click", section.dataItem);
		}
		function prepareRenderData(data) {
			const result = Array();
			const computedStyle = rootComputedStyles.value;
			if (!computedStyle) return result;
			const inner_scaled = scale(radiusInner.value);
			const outer_scaled = scale(radiusOuter.value);
			const range_deg = props.degEnd - props.degStart;
			let increment_deg = props.degStart;
			for (let index = 0; index < data.length; index++) {
				const dataItem = data[index];
				let partSize = dataItem.partSize;
				if (isNaN(partSize) || partSize < 0) partSize = 0;
				let partSize_deg = partSize / total.value * range_deg;
				if (partSize_deg == 0) continue;
				partSize_deg *= animationProgress;
				let extrusionFactor = dataItem.extrusion;
				if (!extrusionFactor) extrusionFactor = props.defaultExtrusion;
				const outerRadius = inner_scaled + (outer_scaled - inner_scaled) * extrusionFactor;
				const arcPath = makeArcPath(increment_deg, increment_deg + partSize_deg, inner_scaled, outerRadius);
				const textAngle_deg = increment_deg + partSize_deg / 2;
				let textClass = "";
				if (props.labelAlign == "auto") textClass = "v-pie-chart-angle-" + getClassForAngle(textAngle_deg);
				const style = {
					fill: computedStyle.getPropertyValue(`--data-item-fill-color-${index}`),
					stroke: computedStyle.getPropertyValue(`--data-item-stroke-color-${index}`),
					strokeWidth: computedStyle.getPropertyValue(`--data-item-stroke-width-${index}`)
				};
				result.push({
					index,
					dataItem,
					path: arcPath,
					style,
					textPos: polarToCartesian(scale(radiusLabels.value), textAngle_deg),
					class: textClass
				});
				increment_deg += partSize_deg;
			}
			return result;
		}
		function scale(val) {
			return val * (Math.min(viewboxSize.value.x, viewboxSize.value.y) / 2);
		}
		watch(() => viewboxSize.value, () => {
			renderData.value = prepareRenderData(props.data);
		});
		watch(() => [props.data], (newval, oldval) => {
			if (newval == oldval || JSON.stringify(newval) == JSON.stringify(oldval)) return;
			animationProgress = 0;
			window.clearInterval(animationIntervalHandle);
			if (props.animationSpeed > 0 && props.animationSpeed < 1) animationIntervalHandle = window.setInterval(() => {
				window.requestAnimationFrame(() => {
					animationProgress += props.animationSpeed;
					if (animationProgress >= 1) {
						animationProgress = 1;
						window.clearInterval(animationIntervalHandle);
					}
					renderData.value = prepareRenderData(props.data);
				});
			}, 25);
			else animationProgress = 1;
			renderData.value = prepareRenderData(props.data);
			emit("update:legend-data-out", buildLegendData(renderData.value));
		}, { immediate: true });
		onMounted(() => {
			emit("update:legend-data-out", buildLegendData(renderData.value));
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "rootElement",
				ref: rootElement,
				class: "v-pie-chart"
			}, [createElementVNode("div", _hoisted_1$13, [renderSlot(_ctx.$slots, "default")]), (openBlock(), createElementBlock("svg", {
				ref_key: "svg",
				ref: svg,
				draggable: "false"
			}, [createElementVNode("g", { style: normalizeStyle(`transform:translate(${unref(viewboxSize).x / 2}px, ${unref(viewboxSize).y / 2}px`) }, [createElementVNode("path", {
				d: getBackgroundPath(__props.data),
				class: "v-pie-chart__background"
			}, null, 8, _hoisted_2$9), createElementVNode("g", _hoisted_3$7, [(openBlock(true), createElementBlock(Fragment, null, renderList(renderData.value, (section, index) => {
				return openBlock(), createElementBlock("g", { class: normalizeClass(`v-pie-chart__section v-pie-chart__section-${index} ${mouseoverSection.value == section ? "x-hover" : ""}`) }, [createElementVNode("path", {
					d: section.path,
					"data-tooltip": props.tooltipFunc(section),
					class: normalizeClass(`v-pie-chart__section-${index}`),
					style: normalizeStyle(section.style),
					onMouseover: ($event) => onMouseOverSection(section),
					onMouseout: ($event) => onMouseOutSection(section),
					onClick: ($event) => onSectionClick(section)
				}, null, 46, _hoisted_4$6)], 2);
			}), 256)), (openBlock(true), createElementBlock(Fragment, null, renderList(renderData.value, (section) => {
				return openBlock(), createElementBlock("g", {
					class: normalizeClass(getSectionClass(section)),
					style: normalizeStyle(`transform:translate(${section.textPos.x}px ,${section.textPos.y}px);`)
				}, [createElementVNode("text", {
					class: normalizeClass(section.class),
					innerHTML: props.labelFunc(section)
				}, null, 10, _hoisted_5)], 6);
			}), 256))])], 4)], 512))], 512);
		};
	}
});
//#endregion
//#region src/composables/useOnOutsideClick.ts
function useOnOutsideClick(target, callback) {
	function onWindowMouseDown(evt) {
		const elem = unref(target);
		if (elem == null || elem == evt.target || elem.contains(evt.target)) return;
		callback(evt);
	}
	useEventListener(document, "mousedown", onWindowMouseDown);
}
//#endregion
//#region src/components/Popup.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$12 = {
	key: 0,
	class: "v-popup__clickblocker"
};
var _hoisted_2$8 = { class: "v-popup__header" };
var _hoisted_3$6 = ["innerHTML"];
var _hoisted_4$5 = { class: "v-popup__body" };
//#endregion
//#region src/components/Popup.vue
var Popup_default = /* @__PURE__ */ defineComponent({
	__name: "Popup",
	props: {
		allowOutsideInteraction: {
			type: Boolean,
			default: false
		},
		closeOnOutsideClick: {
			type: Boolean,
			default: true
		},
		docked: {
			type: Boolean,
			default: false
		},
		show: { type: Boolean },
		showDockButton: {
			type: Boolean,
			default: false
		},
		title: {}
	},
	emits: [
		"update:show",
		"update:docked",
		"close"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const panel = ref(null);
		const rootElem = ref(null);
		useOnOutsideClick(panel, onOutsideClick);
		const showDelayed = ref(false);
		const docked = ref(props.docked);
		function getClasses() {
			return {
				"v-popup": true,
				"x-docked": docked.value,
				"v-popup--visible": showDelayed.value,
				"v-popup--hidden": !showDelayed.value
			};
		}
		function hide() {
			emit("update:show", false);
			emit("close");
		}
		function onOutsideClick(_evt) {
			if (docked.value) return;
			if (showDelayed.value && props.closeOnOutsideClick) hide();
		}
		watch(() => props.show, (newval) => {
			if (rootElem.value) document.getElementsByTagName("body")[0].appendChild(rootElem.value);
			if (newval && !props.allowOutsideInteraction) {
				document.body.style.marginRight = getDocumentScrollbarWidth() + "px";
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.removeProperty("overflow");
				document.body.style.removeProperty("margin-right");
			}
			window.setTimeout(() => {
				showDelayed.value = newval;
			}, 0);
		}, { immediate: true });
		watch(() => docked.value, () => {
			emit("update:docked", docked.value);
		});
		watch(() => props.docked, (newval) => {
			docked.value = newval;
		}, { immediate: true });
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "rootElem",
				ref: rootElem,
				class: normalizeClass(getClasses())
			}, [showDelayed.value && !__props.allowOutsideInteraction ? (openBlock(), createElementBlock("div", _hoisted_1$12)) : createCommentVNode("", true), createElementVNode("div", {
				ref_key: "panel",
				ref: panel,
				class: "v-popup__panel"
			}, [createElementVNode("div", _hoisted_2$8, [
				createElementVNode("h1", { innerHTML: __props.title }, null, 8, _hoisted_3$6),
				props.showDockButton ? (openBlock(), createBlock(SmartButton_default, {
					key: 0,
					modelValue: docked.value,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => docked.value = $event),
					class: "v-popup__header__button-dock",
					boolean: "",
					"data-tooltip": docked.value ? "Ablösen" : "Anpinnen"
				}, null, 8, ["modelValue", "data-tooltip"])) : createCommentVNode("", true),
				createElementVNode("button", {
					class: "v-popup__header__button-close",
					"data-tooltip": "Schließen",
					onClick: hide
				})
			]), createElementVNode("div", _hoisted_4$5, [renderSlot(_ctx.$slots, "default")])], 512)], 2);
		};
	}
});
//#endregion
//#region src/components/ProgressBar.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$11 = [
	"data-tooltip",
	"aria-valuenow",
	"aria-valuemin",
	"aria-valuemax",
	"aria-valuetext",
	"aria-label"
];
var _hoisted_2$7 = { class: "v-progress-bar__background" };
//#endregion
//#region src/components/ProgressBar.vue
var ProgressBar_default = /* @__PURE__ */ defineComponent({
	__name: "ProgressBar",
	props: {
		label: { default: "progress" },
		colorFunc: {},
		tooltipFunc: {},
		max: { default: 1 },
		min: { default: 0 },
		value: { default: .5 }
	},
	setup(__props) {
		const props = __props;
		const barClass = computed(() => {
			return {
				"v-progress-bar": true,
				"x-positive": props.value > 0,
				"x-negative": props.value < 0
			};
		});
		const barStyle = computed(() => {
			return {
				left: getLeft() * 100 + "%",
				width: getWidth() * 100 + "%",
				"background-color": typeof props.colorFunc === "function" ? props.colorFunc(scale(props.value)) : void 0
			};
		});
		function getWidth() {
			return Math.abs(scale(props.value) - scale(0));
		}
		function getLeft() {
			return props.value >= 0 ? scale(0) : scale(0) - getWidth();
		}
		function getTooltip() {
			if (typeof props.tooltipFunc == "function") return props.tooltipFunc(props.value);
			else return props.value.toString();
		}
		function scale(value) {
			const min = Math.min(props.min, 0);
			const range = Math.abs(props.max - min);
			return (value - min) / range;
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: normalizeClass(barClass.value),
				"data-tooltip": getTooltip(),
				role: "progressbar",
				"aria-valuenow": props.value,
				"aria-valuemin": props.min,
				"aria-valuemax": props.max,
				"aria-valuetext": getTooltip(),
				"aria-label": props.label
			}, [createElementVNode("div", _hoisted_2$7, [createElementVNode("div", {
				class: "v-progress-bar__bar",
				style: normalizeStyle(barStyle.value)
			}, null, 4)])], 10, _hoisted_1$11);
		};
	}
});
//#endregion
//#region src/components/PropertyGrid.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$10 = {
	key: 0,
	class: "v-property-grid"
};
var _hoisted_2$6 = ["innerHTML"];
var _hoisted_3$5 = ["innerHTML"];
//#endregion
//#region src/components/PropertyGrid.vue
var PropertyGrid_default = /* @__PURE__ */ defineComponent({
	__name: "PropertyGrid",
	props: {
		config: { default: () => ({}) },
		object: {}
	},
	setup(__props) {
		const props = __props;
		const displayedKeys = computed(() => {
			let result = Array();
			if (props.config?.showOnlyConfiguredFields) {
				result = Object.keys(props.config?.fields);
				return result;
			}
			for (const key in props.object) {
				if (props.config?.fields[key]?.show === false) continue;
				result.push(key);
			}
			result.sort();
			return result;
		});
		function getDisplayValue(key) {
			const propertyDef = props.config?.fields[key];
			if (propertyDef) {
				if (typeof propertyDef?.displayFunc == "function") return propertyDef.displayFunc(props.object);
				const value = (propertyDef.valueFunc || ((obj) => obj[key]))(props.object);
				switch (propertyDef.type) {
					case "url": return `<a target="_blank" href="${value}">${value}</a>`;
					case "email": return `<a target="_blank" href="mailto:${value}">${value}</a>`;
					default: break;
				}
			}
			switch (typeof props.object[key]) {
				case "object": return JSON.stringify(props.object[key]);
				case "string": return props.object[key];
				default: return JSON.stringify(props.object[key]);
			}
		}
		function getLabel(key) {
			return props.config?.fields?.[key]?.label || key;
		}
		return (_ctx, _cache) => {
			return props.object ? (openBlock(), createElementBlock("div", _hoisted_1$10, [(openBlock(true), createElementBlock(Fragment, null, renderList(displayedKeys.value, (key) => {
				return openBlock(), createElementBlock("div", null, [createElementVNode("h2", { innerHTML: getLabel(key) + ":" }, null, 8, _hoisted_2$6), createElementVNode("div", { innerHTML: getDisplayValue(key) }, null, 8, _hoisted_3$5)]);
			}), 256))])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/scrollSensor/ScrollSensor.vue
var ScrollSensor_default = /* @__PURE__ */ defineComponent({
	__name: "ScrollSensor",
	props: {
		info: { default: null },
		sensorOffsetYPercent: { default: 50 },
		updateOnResize: {
			type: Boolean,
			default: true
		},
		debug: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:info"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const sensorElemRef = ref(null);
		/** Viewport-relative bounding rect of the sensor element, updated on scroll and resize. */
		const sensorRect = ref(null);
		const emit = __emit;
		const scrollItems = Array();
		let prevItem = null;
		let currentItem = null;
		/** Tracks whether update() has run at least once, so the initial null state is always emitted. */
		let hasEmittedOnce = false;
		/** rAF handle for throttling updates. */
		let rafHandle = null;
		/** Collect all scrollable ancestors of the sensor element. */
		function getScrollAncestors(el) {
			const result = [];
			let current = el.parentElement;
			while (current) {
				const style = window.getComputedStyle(current);
				const overflow = style.overflow + style.overflowY + style.overflowX;
				if (/auto|scroll/.test(overflow)) result.push(current);
				current = current.parentElement;
			}
			result.push(document.documentElement);
			return result;
		}
		let scrollAncestors = [];
		let resizeObserver = null;
		function scheduleUpdate() {
			if (rafHandle !== null) return;
			rafHandle = requestAnimationFrame(() => {
				rafHandle = null;
				update();
			});
		}
		onMounted(() => {
			const el = sensorElemRef.value;
			if (!el) return;
			scrollAncestors = getScrollAncestors(el);
			for (const ancestor of scrollAncestors) ancestor.addEventListener("scroll", scheduleUpdate, { passive: true });
			window.addEventListener("scroll", scheduleUpdate, { passive: true });
			resizeObserver = new ResizeObserver(scheduleUpdate);
			resizeObserver.observe(el);
			for (const ancestor of scrollAncestors) resizeObserver.observe(ancestor);
			requestAnimationFrame(() => {
				update();
			});
		});
		onBeforeUnmount(() => {
			if (rafHandle !== null) {
				cancelAnimationFrame(rafHandle);
				rafHandle = null;
			}
			for (const ancestor of scrollAncestors) ancestor.removeEventListener("scroll", scheduleUpdate);
			window.removeEventListener("scroll", scheduleUpdate);
			resizeObserver?.disconnect();
			resizeObserver = null;
		});
		function addItem(item) {
			scrollItems.push(item);
			scheduleUpdate();
		}
		function emitInfo() {
			const info = markRaw({
				allItems: scrollItems,
				currentItem
			});
			emit("update:info", info);
		}
		function update() {
			if (!sensorElemRef.value) return;
			const scrollContainer = scrollAncestors[0] ?? document.documentElement;
			const containerBox = scrollContainer === document.documentElement ? new DOMRect(0, 0, window.innerWidth, window.innerHeight) : scrollContainer.getBoundingClientRect();
			const prev = sensorRect.value;
			if (!prev || prev.top !== containerBox.top || prev.left !== containerBox.left || prev.width !== containerBox.width || prev.height !== containerBox.height) sensorRect.value = containerBox;
			const sensorLine_y = containerBox.top + containerBox.height * (props.sensorOffsetYPercent / 100);
			currentItem = null;
			for (const item of scrollItems) {
				const itemBox = item.elem.getBoundingClientRect();
				if (itemBox.top <= sensorLine_y && itemBox.bottom >= sensorLine_y) {
					currentItem = item;
					break;
				}
			}
			if (prevItem !== currentItem || !hasEmittedOnce) {
				if (prevItem != null) {
					prevItem.props.onLeave?.();
					prevItem.elem.classList.remove("x-scroll-sensor-active");
				}
				if (currentItem != null) {
					currentItem.props.onEnter?.();
					currentItem.elem.classList.add("x-scroll-sensor-active");
				}
				hasEmittedOnce = true;
				emitInfo();
			}
			prevItem = currentItem;
		}
		provide("scroll-sensor", { addItem });
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", {
				ref_key: "sensorElemRef",
				ref: sensorElemRef,
				class: "v-scroll-sensor"
			}, [renderSlot(_ctx.$slots, "default")], 512), (openBlock(), createBlock(Teleport, { to: "body" }, [props.debug && sensorRect.value ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: "v-scroll-sensor-debug-line",
				style: normalizeStyle({
					left: sensorRect.value.left + "px",
					top: sensorRect.value.top + sensorRect.value.height * (props.sensorOffsetYPercent / 100) + "px",
					width: sensorRect.value.width + "px"
				})
			}, null, 4)) : createCommentVNode("", true)]))], 64);
		};
	}
});
//#endregion
//#region src/components/scrollSensor/ScrollSensorItem.vue
var ScrollSensorItem_default = /* @__PURE__ */ defineComponent({
	__name: "ScrollSensorItem",
	props: {
		data: {},
		onEnter: { type: Function },
		onLeave: { type: Function }
	},
	setup(__props) {
		const props = __props;
		const scrollSensor = inject("scroll-sensor");
		const rootElem = ref(null);
		onMounted(() => {
			if (!scrollSensor) return;
			const elem = rootElem.value;
			if (!elem) return;
			scrollSensor.addItem({
				elem,
				props
			});
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "rootElem",
				ref: rootElem,
				class: "v-scroll-sensor-item"
			}, [renderSlot(_ctx.$slots, "default")], 512);
		};
	}
});
//#endregion
//#region src/components/scrollSensor/ScrollSensorMenu.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$9 = {
	key: 0,
	class: "v-scroll-sensor-menu"
};
var _hoisted_2$5 = ["data-tooltip"];
var _hoisted_3$4 = ["onClick"];
var _hoisted_4$4 = ["innerHTML"];
//#endregion
//#region src/components/scrollSensor/ScrollSensorMenu.vue
var ScrollSensorMenu_default = /* @__PURE__ */ defineComponent({
	__name: "ScrollSensorMenu",
	props: { data: {} },
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return props.data ? (openBlock(), createElementBlock("ul", _hoisted_1$9, [(openBlock(true), createElementBlock(Fragment, null, renderList(props.data.allItems, (item) => {
				return openBlock(), createElementBlock("li", {
					class: normalizeClass({ "x-selected": item == props.data.currentItem ? true : false }),
					"data-tooltip": item.props?.data?.label
				}, [createElementVNode("button", { onClick: ($event) => item.elem.scrollIntoView({
					behavior: "smooth",
					block: "start"
				}) }, [renderSlot(_ctx.$slots, "item-label", { item }, () => [createElementVNode("div", { innerHTML: item.props?.data?.label }, null, 8, _hoisted_4$4)])], 8, _hoisted_3$4)], 10, _hoisted_2$5);
			}), 256))])) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/components/SmartRangeInput.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$8 = { class: "v-smart-range-input" };
var _hoisted_2$4 = {
	key: 0,
	class: "v-smart-range-input__range-label"
};
var _hoisted_3$3 = [
	"min",
	"max",
	"step",
	"data-tooltip"
];
var _hoisted_4$3 = {
	key: 1,
	class: "v-smart-range-input__range-label"
};
//#endregion
//#region src/components/SmartRangeInput.vue
var SmartRangeInput_default = /* @__PURE__ */ defineComponent({
	__name: "SmartRangeInput",
	props: {
		max: { default: 100 },
		min: { default: 1 },
		modelValue: { default: 0 },
		step: {},
		showLabels: {
			type: Boolean,
			default: true
		},
		tooltipFunc: {}
	},
	emits: ["update:modelValue"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const tooltipFunc = computed(() => {
			if (typeof props.tooltipFunc == "function") return props.tooltipFunc;
			return () => value.value;
		});
		const value = computed({
			get() {
				if (props.modelValue == void 0) return "";
				return props.modelValue.toString();
			},
			set(newValue) {
				emit("update:modelValue", parseFloat(newValue));
			}
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$8, [
				props.showLabels ? (openBlock(), createElementBlock("div", _hoisted_2$4, toDisplayString(props.min), 1)) : createCommentVNode("", true),
				withDirectives(createElementVNode("input", {
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => value.value = $event),
					type: "range",
					min: props.min,
					max: props.max,
					step: __props.step,
					"data-tooltip": tooltipFunc.value()
				}, null, 8, _hoisted_3$3), [[vModelText, value.value]]),
				props.showLabels ? (openBlock(), createElementBlock("div", _hoisted_4$3, toDisplayString(props.max), 1)) : createCommentVNode("", true)
			]);
		};
	}
});
//#endregion
//#region src/components/smartTable/SmartTable.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$7 = { class: "v-smart-table" };
var _hoisted_2$3 = [
	"data-tooltip",
	"aria-sort",
	"aria-label",
	"onClick",
	"onKeydown",
	"innerHTML"
];
var _hoisted_3$2 = [
	"onMouseover",
	"onMouseout",
	"onClick"
];
var _hoisted_4$2 = ["innerHTML"];
//#endregion
//#region src/components/smartTable/SmartTable.vue
var SmartTable_default = /* @__PURE__ */ defineComponent({
	__name: "SmartTable",
	props: {
		items: { default: () => [] },
		downloadFileName: { default: "table.csv" },
		fields: {},
		hover: { default: () => [] },
		initialSortField: { default: -1 },
		initialSortDir: { default: 1 },
		onBodyCellClick: {},
		selectMode: { default: SelectMode.None },
		selected: { default: () => [] },
		triggerDownload: {
			type: Boolean,
			default: false
		}
	},
	emits: [
		"update:hover",
		"update:selected",
		"update:selected-field",
		"row-mouse-out",
		"row-mouse-over",
		"row-click"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const sortColIndex = ref(props.initialSortField);
		const sortDir = ref(props.initialSortDir > 0 ? 1 : -1);
		const emit = __emit;
		const fields = computed(() => {
			if (props.fields) return props.fields;
			if (!props.items) return [];
			let keys = Array();
			for (const row of props.items) keys = keys.concat(Object.keys(row));
			keys = Array.from(/* @__PURE__ */ new Set([...keys]));
			const result = Array();
			for (const key of keys) result.push({
				key,
				label: key
			});
			return result;
		});
		const rowsOrdered = computed(() => {
			let result = props.items;
			const sortColumn = fields.value[sortColIndex.value];
			if (!sortColumn || !isSortable(sortColumn)) return result;
			result = [...props.items].sort(compareItems);
			return result.filter((row) => row._sticky).concat(result.filter((row) => !row._sticky));
		});
		function compareItems(item1, item2) {
			const sortColumn = fields.value[sortColIndex.value];
			if (!sortColumn) return 0;
			const cf = typeof sortColumn.valueFunc == "function" ? sortColumn.valueFunc : (item) => item;
			const v1 = cf(item1);
			const v2 = cf(item2);
			if (v1 < v2) return -1 * sortDir.value;
			else if (v1 > v2) return 1 * sortDir.value;
			return 0;
		}
		function getDisplayString(item, col) {
			let result = item[col.key];
			if (typeof col.valueFunc == "function") try {
				result = col.valueFunc(item);
			} catch (e) {
				console.warn("SmartTable: Error in cell value function");
			}
			if (typeof col.displayFunc == "function") try {
				result = col.displayFunc(item);
			} catch (e) {
				console.warn("SmartTable: Error in cell value display function");
			}
			return result;
		}
		function getHeaderCellClass(field) {
			const colIndex = fields.value.indexOf(field);
			const result = {};
			if (field.htmlClass) result[field.htmlClass] = true;
			if (!isSortable(field)) return result;
			result["v-smart-table__header-cell-sortable"] = true;
			if (colIndex == sortColIndex.value) {
				result["v-smart-table__header-cell--asc"] = sortDir.value == 1;
				result["v-smart-table__header-cell--desc"] = sortDir.value == -1;
			} else result["v-smart-table__header-cell--unsorted"] = true;
			return result;
		}
		function getHeaderCellTooltip(col) {
			if (!isSortable(col)) return "";
			if (col.label) return `<strong>${sortDir.value < 0 ? "Aufsteigend" : "Absteigend"} nach ${col.label}</strong> sortieren`;
			else return "Nach dieser Spalte sortieren";
		}
		function getHeaderCellAriaSort(col) {
			if (!isSortable(col)) return;
			if (fields.value.indexOf(col) !== sortColIndex.value) return "none";
			return sortDir.value === 1 ? "ascending" : "descending";
		}
		function getHeaderCellAriaLabel(col) {
			let labelText = col.label ? col.label.replace(/<[^>]*>/g, "") : col.key;
			labelText = htmlConvert(labelText);
			if (!isSortable(col)) return labelText;
			const colIndex = fields.value.indexOf(col);
			let nextSortDir = sortDir.value;
			if (colIndex === sortColIndex.value) nextSortDir = -sortDir.value;
			return `${labelText}, ${nextSortDir > 0 ? "Aufsteigend sortieren" : "Absteigend sortieren"}`;
		}
		function getRowClass(row, index) {
			const hoverItems = makeArray(props.hover);
			const selectedItems = makeArray(props.selected);
			return {
				"x-clickable": typeof props.onBodyCellClick == "function" || props.selectMode != SelectMode.None,
				"x-hover": hoverItems.includes(row),
				"x-selected": selectedItems.includes(row),
				[row["_htmlclass"]]: row["_htmlclass"]
			};
		}
		function isSortable(col) {
			return col.sortable !== void 0 ? col.sortable : true;
		}
		function onBodyCellClick(item, column) {
			if (typeof props.onBodyCellClick == "function") props.onBodyCellClick(item, column);
			let compareFunc = (item) => item;
			emit("update:selected-field", column);
			emit("update:selected", handleSelection(props.selected, item, props.selectMode, true, compareFunc));
			emit("row-click", {
				item,
				column
			});
		}
		function onBodyCellMouseOver(item, column) {
			emit("update:hover", [item]);
			emit("row-mouse-over", {
				item,
				column
			});
		}
		function onBodyCellMouseOut(item, column) {
			emit("update:hover", []);
			emit("row-mouse-out", {
				item,
				column
			});
		}
		function onHeaderCellClick(field) {
			if (field.sortable === false) return;
			const newSortIndex = fields.value.indexOf(field);
			if (newSortIndex == sortColIndex.value) sortDir.value = -sortDir.value;
			sortColIndex.value = newSortIndex;
		}
		function startDownload() {
			const text = buildCsv();
			const blob = new Blob([text], { type: "text/csv" });
			const link = document.createElement("a");
			link.href = window.URL.createObjectURL(blob);
			link.download = props.downloadFileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
		function buildCsv() {
			let result = "";
			for (const field of fields.value) if (field.label) result += htmlConvert(field.label) + ";";
			else result += htmlConvert(field.key) + ";";
			result += "\n";
			for (const item of rowsOrdered.value) {
				for (const field of fields.value) {
					let value = item[field.key];
					if (field.valueFunc) value = field.valueFunc(item);
					result += value;
					result += ";";
				}
				result += "\n";
			}
			return result;
		}
		function htmlConvert(text) {
			let result = text;
			result = result.replace(/&gt;/g, ">");
			result = result.replace(/&lt;/g, "<");
			result = result.replace(/&nbsp;/g, " ");
			return result;
		}
		watch(() => props.triggerDownload, () => {
			startDownload();
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$7, [createElementVNode("table", null, [createElementVNode("thead", null, [createElementVNode("tr", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(fields.value, (col) => {
				return openBlock(), createElementBlock("th", {
					class: normalizeClass(getHeaderCellClass(col)),
					"data-tooltip": getHeaderCellTooltip(col),
					"aria-sort": getHeaderCellAriaSort(col),
					"aria-label": getHeaderCellAriaLabel(col),
					scope: "col",
					role: "columnheader",
					tabindex: "0",
					onClick: ($event) => onHeaderCellClick(col),
					onKeydown: [withKeys(($event) => onHeaderCellClick(col), ["enter"]), withKeys(withModifiers(($event) => onHeaderCellClick(col), ["prevent"]), ["space"])],
					innerHTML: col.label
				}, null, 42, _hoisted_2$3);
			}), 256))])]), createElementVNode("tbody", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(rowsOrdered.value, (row, index) => {
				return openBlock(), createElementBlock("tr", { class: normalizeClass(getRowClass(row, index)) }, [(openBlock(true), createElementBlock(Fragment, null, renderList(fields.value, (field) => {
					return openBlock(), createElementBlock("td", {
						class: normalizeClass(field.htmlClass),
						tabindex: "0",
						onMouseover: ($event) => onBodyCellMouseOver(row, field),
						onMouseout: ($event) => onBodyCellMouseOut(row, field),
						onClick: ($event) => onBodyCellClick(row, field)
					}, [renderSlot(_ctx.$slots, `col-${field.key}`, { item: row }, () => [createElementVNode("div", { innerHTML: getDisplayString(row, field) }, null, 8, _hoisted_4$2)])], 42, _hoisted_3$2);
				}), 256))], 2);
			}), 256))])])]);
		};
	}
});
//#endregion
//#region src/components/SmartTextInput.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$6 = { class: "v-smart-text-input" };
var _hoisted_2$2 = [
	"list",
	"placeholder",
	"data-tooltip",
	"disabled"
];
var _hoisted_3$1 = ["id"];
var _hoisted_4$1 = ["value"];
//#endregion
//#region src/components/SmartTextInput.vue
var SmartTextInput_default = /* @__PURE__ */ defineComponent({
	__name: "SmartTextInput",
	props: {
		suggestionTextFunc: {
			type: Function,
			default: (item) => item
		},
		modelValue: { default: "" },
		placeholder: { default: "" },
		suggestions: { default: () => [] },
		disabled: {
			type: Boolean,
			default: false
		},
		clearOnEnter: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:modelValue", "enter"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const pValue = ref(props.modelValue);
		const input = ref(null);
		ref(null);
		const hover = ref(false);
		const tooltip = ref("");
		const id = ref("id_" + uuid.v4().toString());
		const dynamicClass = computed(() => {
			return {
				"v-smart-text-input__input": true,
				"v-smart-text-input__input--hover": hover.value
			};
		});
		function onClick(evt) {
			if (!hover.value) return;
			evt.preventDefault();
			pValue.value = "";
		}
		function onKeyDown(evt) {
			if (evt.key === "Enter") {
				if (pValue.value == "") return;
				emit("enter");
				if (props.clearOnEnter) {
					pValue.value = "";
					emit("update:modelValue", pValue.value);
				}
			}
		}
		function onMouseMove(evt) {
			if (!input.value || props.disabled) return;
			hover.value = evt.offsetX > input.value.offsetWidth - 24;
			tooltip.value = hover.value ? "Eingabe löschen" : "";
		}
		function stf(item) {
			return props.suggestionTextFunc(item);
		}
		watch(() => pValue.value, () => {
			emit("update:modelValue", pValue.value);
		});
		watch(() => props.modelValue, () => {
			pValue.value = props.modelValue;
		});
		watch(() => props.suggestions, () => {});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$6, [withDirectives(createElementVNode("input", {
				ref_key: "input",
				ref: input,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => pValue.value = $event),
				list: id.value,
				type: "text",
				class: normalizeClass(dynamicClass.value),
				placeholder: __props.placeholder,
				"data-tooltip": tooltip.value,
				disabled: props.disabled,
				onKeydown: onKeyDown,
				onClick,
				onMousemove: onMouseMove
			}, null, 42, _hoisted_2$2), [[vModelText, pValue.value]]), createElementVNode("datalist", { id: id.value }, [(openBlock(true), createElementBlock(Fragment, null, renderList(props.suggestions, (item) => {
				return openBlock(), createElementBlock("option", { value: stf(item) }, null, 8, _hoisted_4$1);
			}), 256))], 8, _hoisted_3$1)]);
		};
	}
});
//#endregion
//#region src/components/SplitPanel.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$5 = ["aria-orientation", "aria-valuenow"];
//#endregion
//#region src/components/SplitPanel.vue
var SplitPanel_default = /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SplitPanel",
	props: { ratio: { default: 50 } },
	emits: ["update:ratio"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const containerElem = ref(null);
		const dragHandle = ref(null);
		const { pos: dragPos, isDragging } = useDragPosition(dragHandle);
		const containerSize = useElementSize(containerElem);
		const emit = __emit;
		const _ratio = ref(props.ratio);
		const ratio = computed({
			get() {
				return _ratio.value;
			},
			set(value) {
				value = Math.max(value, 0);
				value = Math.min(value, 100);
				_ratio.value = value;
				emit("update:ratio", _ratio.value);
			}
		});
		const dragHandleStyle = computed(() => {
			const result = {};
			if (landscapeMode.value) {
				result.left = `calc(${ratio.value}%)`;
				result.top = "50%";
			} else {
				result.top = `calc(${ratio.value}%)`;
				result.left = "50%";
			}
			return result;
		});
		const landscapeMode = computed(() => {
			const { x, y } = containerSize.value;
			if (x === 0 && y === 0) return true;
			return x > y;
		});
		function onHandleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
		}
		function onHandleKeyDown(event) {
			let handled = true;
			const step = 5;
			switch (event.key) {
				case "ArrowLeft":
				case "ArrowUp":
					ratio.value -= step;
					break;
				case "ArrowRight":
				case "ArrowDown":
					ratio.value += step;
					break;
				case "Home":
					ratio.value = 0;
					break;
				case "End":
					ratio.value = 100;
					break;
				default:
					handled = false;
					break;
			}
			if (handled) {
				event.preventDefault();
				event.stopPropagation();
			}
		}
		watch(() => dragPos.value, () => {
			if (!isDragging.value) return;
			let newRatio = ratio.value;
			const elem = containerElem.value;
			if (!elem) return;
			const rect = elem.getBoundingClientRect();
			if (landscapeMode.value) newRatio = Math.round((dragPos.value.x - rect.left) / rect.width * 100);
			else newRatio = Math.round((dragPos.value.y - rect.top) / rect.height * 100);
			ratio.value = newRatio;
		});
		watch(() => props.ratio, () => {
			ratio.value = props.ratio;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "containerElem",
				ref: containerElem,
				class: normalizeClass(["v-split-panel", { portrait: !landscapeMode.value }]),
				style: normalizeStyle({ flexDirection: landscapeMode.value ? "row" : "column" })
			}, [
				createElementVNode("div", {
					class: "v-split-panel__1",
					style: normalizeStyle(`flex: ${ratio.value} 0 0`)
				}, [renderSlot(_ctx.$slots, "panel1", {}, void 0, true)], 4),
				createElementVNode("div", {
					class: "v-split-panel__2",
					style: normalizeStyle(`flex: ${100 - ratio.value} 0 0`)
				}, [renderSlot(_ctx.$slots, "panel2", {}, void 0, true)], 4),
				createElementVNode("div", {
					ref_key: "dragHandle",
					ref: dragHandle,
					class: normalizeClass(["v-split-panel__drag-handle", { "is-dragging": unref(isDragging) }]),
					style: normalizeStyle(dragHandleStyle.value),
					"data-tooltip": "Hier ziehen, um die geteilte Ansicht zu skalieren",
					role: "separator",
					"aria-orientation": landscapeMode.value ? "vertical" : "horizontal",
					"aria-valuenow": Math.round(ratio.value),
					"aria-valuemin": "0",
					"aria-valuemax": "100",
					"aria-label": "Teiler verschieben",
					tabindex: "0",
					onMousedown: onHandleMouseDown,
					onTouchstart: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"])),
					onKeydown: onHandleKeyDown
				}, null, 46, _hoisted_1$5)
			], 6);
		};
	}
}), [["__scopeId", "data-v-25928ada"]]);
//#endregion
//#region src/components/Tab.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$4 = [
	"id",
	"aria-labelledby",
	"tabindex",
	"hidden"
];
//#endregion
//#region src/components/Tab.vue
var Tab_default = /* @__PURE__ */ defineComponent({
	__name: "Tab",
	props: {
		label: {},
		tabKey: {}
	},
	setup(__props) {
		const props = __props;
		const activeTab = inject("tabsGroupActiveTab", ref(null));
		const instanceId = inject("tabsGroupInstanceId", "v-tabs-orphan");
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: normalizeClass(["v-tab", {
					"x-active": unref(activeTab) === props.tabKey,
					"x-inactive": unref(activeTab) !== props.tabKey
				}]),
				role: "tabpanel",
				id: `${unref(instanceId)}-tabpanel-${props.tabKey}`,
				"aria-labelledby": `${unref(instanceId)}-tab-${props.tabKey}`,
				tabindex: unref(activeTab) === props.tabKey ? 0 : -1,
				hidden: unref(activeTab) !== props.tabKey
			}, [renderSlot(_ctx.$slots, "default")], 10, _hoisted_1$4);
		};
	}
});
//#endregion
//#region src/components/TabsGroup.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$3 = { class: "v-tabs-group" };
var _hoisted_2$1 = {
	class: "v-tabs-group__buttons v-list v-list-tabs",
	role: "tablist",
	"aria-orientation": "horizontal"
};
var _hoisted_3 = [
	"onClick",
	"onKeydown",
	"id",
	"aria-controls",
	"aria-selected",
	"tabindex"
];
var _hoisted_4 = { class: "v-tabs-group__panels" };
var instanceIdCounter = 0;
//#endregion
//#region src/components/TabsGroup.vue
var TabsGroup_default = /* @__PURE__ */ defineComponent({
	__name: "TabsGroup",
	props: { initialTab: {} },
	setup(__props) {
		const slots = useSlots();
		const props = __props;
		const instanceId = `v-tabs-${instanceIdCounter++}`;
		const activeTab = ref(null);
		const tabRefs = ref([]);
		provide("tabsGroupActiveTab", activeTab);
		provide("tabsGroupInstanceId", instanceId);
		const selectedArray = computed({
			get() {
				if (!activeTab.value) return [];
				return tabs.value.filter((t) => t.key === activeTab.value);
			},
			set(newValue) {
				activeTab.value = newValue.length > 0 ? newValue[0].key : null;
			}
		});
		const tabs = computed(() => {
			const defaultSlot = slots.default?.({});
			if (!defaultSlot) return [];
			return defaultSlot.filter((vnode) => vnode.props?.tabKey ?? vnode.props?.["tab-key"]).map((vnode) => ({
				label: vnode.props.label ?? vnode.props.name,
				key: vnode.props.tabKey ?? vnode.props["tab-key"]
			}));
		});
		const onKeyDown = (event, index) => {
			let newIndex = -1;
			if (event.key === "ArrowRight" || event.key === "ArrowDown") newIndex = (index + 1) % tabs.value.length;
			else if (event.key === "ArrowLeft" || event.key === "ArrowUp") newIndex = (index - 1 + tabs.value.length) % tabs.value.length;
			else if (event.key === "Home") newIndex = 0;
			else if (event.key === "End") newIndex = tabs.value.length - 1;
			if (newIndex !== -1) {
				event.preventDefault();
				activeTab.value = tabs.value[newIndex].key;
				nextTick(() => {
					tabRefs.value[newIndex]?.focus();
				});
			}
		};
		onMounted(() => {
			nextTick(() => {
				if (tabs.value.length > 0 && !activeTab.value) {
					const initial = props.initialTab ? tabs.value.find((t) => t.key === props.initialTab) : void 0;
					activeTab.value = (initial ?? tabs.value[0]).key;
				}
			});
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$3, [createElementVNode("ul", _hoisted_2$1, [createVNode(HeadlessList_default, {
				selected: selectedArray.value,
				"onUpdate:selected": _cache[0] || (_cache[0] = ($event) => selectedArray.value = $event),
				items: tabs.value,
				"select-mode": unref(SelectMode).SingleArray,
				"compare-func": (item) => JSON.stringify(item),
				"allow-unselect": false
			}, {
				default: withCtx(({ item, index, isSelected, isHover, onItemClick }) => [createElementVNode("li", {
					class: normalizeClass({
						"v-list__item": true,
						"x-selected": isSelected,
						"x-hover": isHover
					}),
					role: "presentation"
				}, [createElementVNode("div", null, [createElementVNode("button", {
					ref: (el) => tabRefs.value[index] = el,
					onClick: ($event) => onItemClick(item),
					onKeydown: ($event) => onKeyDown($event, index),
					role: "tab",
					id: `${instanceId}-tab-${item.key}`,
					"aria-controls": `${instanceId}-tabpanel-${item.key}`,
					"aria-selected": isSelected,
					tabindex: isSelected ? 0 : -1
				}, toDisplayString(item.label), 41, _hoisted_3)])], 2)]),
				_: 1
			}, 8, [
				"selected",
				"items",
				"select-mode",
				"compare-func"
			])]), createElementVNode("div", _hoisted_4, [renderSlot(_ctx.$slots, "default")])]);
		};
	}
});
//#endregion
//#region src/composables/useMousePos.ts
function useMousePos(target, absolute) {
	const mousePos = ref(new Vector2());
	const onMouseMove = (evt) => {
		if (absolute) mousePos.value = new Vector2(evt.clientX, evt.clientY);
		else mousePos.value = new Vector2(evt.offsetX, evt.offsetY);
	};
	const onTouchMove = (evt) => {
		const touch1 = evt.touches[0];
		mousePos.value = new Vector2(touch1.pageX, touch1.pageY);
	};
	useEventListener(target, "mousemove", onMouseMove);
	useEventListener(target, "touchmove", onTouchMove);
	return mousePos;
}
//#endregion
//#region src/composables/useIntervalTimer.ts
function useIntervalTimer(callback, interval_ms) {
	let handle = 0;
	onMounted(() => {
		handle = window.setInterval(callback, interval_ms);
	});
	onBeforeUnmount(() => {
		window.clearInterval(handle);
	});
}
//#endregion
//#region src/components/Tooltip.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$2 = ["innerHTML"];
//#endregion
//#region src/components/Tooltip.vue
var Tooltip_default = /* @__PURE__ */ defineComponent({
	__name: "Tooltip",
	props: {
		enableOnTouch: {
			type: Boolean,
			default: true
		},
		dataPropName: { default: "data-tooltip" },
		timeoutHideMs: { default: 100 },
		timeoutShowMs: { default: 400 }
	},
	setup(__props) {
		const props = __props;
		const mousePos = useMousePos(document, true);
		const showTooltip = ref(false);
		const tooltipText = ref("");
		const rootElem = ref(null);
		let showTimeoutHandle = -1;
		let hideTimeoutHandle = -1;
		const dynamicStyle = computed(() => {
			const tooltipElement = rootElem.value;
			if (tooltipElement == null || mousePos.value == null) return;
			let offset_x = 0;
			let offset_y = 0;
			const margin_x = tooltipElement.offsetWidth / 2 + 10;
			if (mousePos.value.x < margin_x) offset_x = 10;
			else if (mousePos.value.x > document.body.offsetWidth - margin_x) offset_x = -tooltipElement.offsetWidth - 10;
			else offset_x = -tooltipElement.offsetWidth / 2;
			if (mousePos.value.y < tooltipElement.offsetHeight + 20) offset_y = 20;
			else offset_y = -tooltipElement.offsetHeight - 10;
			const left = mousePos.value.x + offset_x;
			const top = mousePos.value.y + offset_y;
			return {
				"left": left + "px",
				"top": top + "px",
				"opacity": showTooltip.value ? "1" : "0"
			};
		});
		function handleElement() {
			let element = document.elementFromPoint(mousePos.value.x, mousePos.value.y);
			if (element == null) return;
			let text = null;
			while (element.parentElement != null) {
				text = element.getAttribute(props.dataPropName);
				if (text != null) break;
				element = element.parentElement;
			}
			if (text == null || text == "" || element.getAttribute("disabled") != null) {
				hide();
				return;
			}
			tooltipText.value = text;
			show();
		}
		function hide() {
			window.clearTimeout(showTimeoutHandle);
			showTimeoutHandle = -1;
			if (hideTimeoutHandle == -1) hideTimeoutHandle = window.setTimeout(() => {
				showTooltip.value = false;
			}, props.timeoutHideMs);
		}
		function show() {
			window.clearTimeout(hideTimeoutHandle);
			hideTimeoutHandle = -1;
			if (showTimeoutHandle == -1) showTimeoutHandle = window.setTimeout(() => {
				showTooltip.value = true;
			}, props.timeoutShowMs);
		}
		if (navigator.maxTouchPoints == 0 || props.enableOnTouch) {
			watch(() => mousePos, handleElement, { deep: true });
			useIntervalTimer(handleElement, 500);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "rootElem",
				ref: rootElem,
				class: "v-tooltip",
				style: normalizeStyle(dynamicStyle.value),
				innerHTML: tooltipText.value
			}, null, 12, _hoisted_1$2);
		};
	}
});
//#endregion
//#region src/util/helpTextRegistry.ts
/**
* A registry for context-sensitive help texts.
*
* Help texts are stored by ID and can be looked up by the ContextHelp component
* when a user clicks on an element with a `data-help` attribute.
*
* This module decouples help content from UI components, allowing texts to be
* defined centrally, loaded dynamically, or fetched from an API.
*/
var helpTexts = /* @__PURE__ */ new Map();
/**
* Register a help text entry.
* @param id - The help ID (matches the value of `data-help` attributes)
* @param content - The help text content (supports HTML)
*/
function registerHelpText(id, content) {
	helpTexts.set(id, content);
}
/**
* Retrieve a help text by ID.
* @param id - The help ID to look up
* @returns The help text content, or `undefined` if not found
*/
function getHelpText(id) {
	return helpTexts.get(id);
}
/**
* Check whether a help text ID exists in the registry.
* @param id - The help ID to check
* @returns `true` if a help text is registered for this ID
*/
function hasHelpText(id) {
	return helpTexts.has(id);
}
/**
* Remove a help text from the registry.
* @param id - The help ID to remove
*/
function removeHelpText(id) {
	helpTexts.delete(id);
}
/**
* Remove all registered help texts.
*/
function clearHelpTexts() {
	helpTexts.clear();
}
//#endregion
//#region src/components/contextHelp/contextHelp.ts
/** Reactive singleton that controls the global context help state. */
var contextHelp = reactive({
	/** Whether context help mode is currently active. */
	enabled: false,
	/** Toggle the context help mode on/off. */
	toggle() {
		this.enabled = !this.enabled;
	},
	/** Enable context help mode. */
	enable() {
		this.enabled = true;
	},
	/** Disable context help mode. */
	disable() {
		this.enabled = false;
	}
});
//#endregion
//#region src/components/contextHelp/ContextHelp.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$1 = ["innerHTML"];
//#endregion
//#region src/components/contextHelp/ContextHelp.vue
var ContextHelp_default = /* @__PURE__ */ defineComponent({
	__name: "ContextHelp",
	props: { dataPropName: { default: "data-help" } },
	setup(__props) {
		const props = __props;
		const showPopup = ref(false);
		const popupTitle = ref("Hilfe");
		const popupContent = ref("");
		/** Map from element to its cached data-help value, so we don't re-traverse the DOM on repeat clicks. */
		const helpCache = /* @__PURE__ */ new WeakMap();
		/**
		* Walk up the DOM tree from the clicked element to find a `data-help` attribute.
		* Uses a WeakMap cache to avoid repeated traversals of the same subtree.
		*/
		function findHelpId(element) {
			const cached = helpCache.get(element);
			if (cached !== void 0) return cached;
			let current = element;
			let result = null;
			while (current != null) {
				const helpId = current.getAttribute(props.dataPropName);
				if (helpId != null && helpId != "") {
					result = helpId;
					break;
				}
				current = current.parentElement;
			}
			helpCache.set(element, result);
			return result;
		}
		function onClick(evt) {
			if (!contextHelp.enabled) return;
			const target = evt.target;
			if (target == null) return;
			if (target.closest(".v-app-header-bar__context-help-button") != null) return;
			const helpId = findHelpId(target);
			if (helpId == null || !hasHelpText(helpId)) return;
			evt.preventDefault();
			evt.stopPropagation();
			deriveTitle(target);
			popupContent.value = getHelpText(helpId) ?? "";
			showPopup.value = true;
		}
		/**
		* Derive a meaningful popup title from the element's context.
		* Looks for the closest heading (h1-h6) in the element's ancestry,
		* or uses the element's own text content (truncated), or falls back to "Hilfe".
		*/
		function deriveTitle(element) {
			let current = element;
			while (current != null) {
				const tagName = current.tagName.toLowerCase();
				if ([
					"h1",
					"h2",
					"h3",
					"h4",
					"h5",
					"h6"
				].includes(tagName)) {
					popupTitle.value = current.textContent?.trim() ?? "Hilfe";
					return;
				}
				const heading = current.querySelector("h1, h2, h3, h4, h5, h6");
				if (heading != null) {
					popupTitle.value = heading.textContent?.trim() ?? "Hilfe";
					return;
				}
				current = current.parentElement;
			}
			const ownText = element.textContent?.trim();
			if (ownText != null && ownText.length > 0) {
				popupTitle.value = ownText.length > 60 ? ownText.substring(0, 57) + "…" : ownText;
				return;
			}
			popupTitle.value = "Hilfe";
		}
		function onPopupClose() {
			showPopup.value = false;
		}
		function setHelpModeActive(active) {
			if (active) document.body.classList.add("context-help-active");
			else document.body.classList.remove("context-help-active");
		}
		watch(() => contextHelp.enabled, (newval) => {
			setHelpModeActive(newval);
			if (!newval) showPopup.value = false;
		}, { immediate: true });
		useEventListener(document, "click", onClick, { capture: true });
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Popup_default, {
				show: showPopup.value,
				"onUpdate:show": _cache[0] || (_cache[0] = ($event) => showPopup.value = $event),
				class: "x-right x-w-500",
				title: "Über das ausgewählte Element",
				"allow-outside-interaction": true,
				"close-on-outside-click": true,
				onClose: onPopupClose
			}, {
				default: withCtx(() => [createElementVNode("div", {
					class: "v-context-help__content",
					innerHTML: popupContent.value
				}, null, 8, _hoisted_1$1)]),
				_: 1
			}, 8, ["show"]);
		};
	}
});
//#endregion
//#region src/components/TreeNode.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = {
	key: 0,
	class: "v-tree-node__body"
};
var _hoisted_2 = {
	key: 1,
	class: "v-tree-node__children"
};
//#endregion
//#region src/components/TreeNode.vue
var TreeNode_default = /* @__PURE__ */ defineComponent({
	__name: "TreeNode",
	props: {
		cid: { default: "node_state" },
		filterFunc: {},
		matchOverride: { type: Boolean },
		showRoot: {
			type: Boolean,
			default: true
		},
		state: {},
		tree: {}
	},
	emits: ["update:state"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const manual_expand = ref(void 0);
		const expanded = computed(() => {
			if (props.tree.force_expanded || !props.showRoot) return true;
			return manual_expand.value || match_node_or_child.value;
		});
		const children = computed(() => {
			let result = Array();
			if (!props.tree) return result;
			if (!(props.tree?.children instanceof Array)) return result;
			const childless = [];
			for (const child of props.tree?.children) if (child.children instanceof Array && child.children.length > 0) result.push(child);
			else childless.push(child);
			result = result.concat(childless);
			return result;
		});
		const dynamicClass = computed(() => {
			return {
				"v-tree-node": true,
				"v-tree-node--rootless": !props.showRoot,
				"v-tree-node--collapsed": !expanded.value,
				"v-tree-node--filter-match": props.filterFunc != void 0 && match_node.value === true
			};
		});
		const match_node = computed(() => {
			return filter(props.tree, props.filterFunc, 0);
		});
		const match_node_or_child = computed(() => {
			return filter(props.tree, props.filterFunc, 1);
		});
		function filter(node, filterFunc, filterMode) {
			if (!(filterFunc instanceof Function)) return;
			if (!node) return;
			const result_node = filterFunc(node);
			if (filterMode == 0 || node.children?.length == 0) return result_node;
			if (result_node === void 0) return;
			let result_children = false;
			if (node.children instanceof Array) {
				for (const child of node.children) if (filter(child, filterFunc, filterMode) === true) {
					result_children = true;
					break;
				}
			}
			return result_node || result_children;
		}
		function toggle() {
			manual_expand.value = !manual_expand.value;
			if (props.cid && props.state) props.state[props.cid] = manual_expand.value;
		}
		if (props.state) {
			const nodeState = props.state[props.cid];
			if (nodeState != void 0) manual_expand.value = nodeState;
		} else emit("update:state", {});
		return (_ctx, _cache) => {
			const _component_TreeNode = resolveComponent("TreeNode", true);
			return match_node_or_child.value !== false || props.matchOverride ? (openBlock(), createElementBlock("div", {
				key: 0,
				class: normalizeClass(dynamicClass.value)
			}, [props.showRoot ? (openBlock(), createElementBlock("div", _hoisted_1, [renderSlot(_ctx.$slots, "body", {
				expanded: expanded.value,
				node: props.tree,
				toggle
			})])) : createCommentVNode("", true), children.value?.length > 0 && expanded.value || !props.showRoot ? (openBlock(), createElementBlock("div", _hoisted_2, [(openBlock(true), createElementBlock(Fragment, null, renderList(children.value, (child, index) => {
				return openBlock(), createBlock(_component_TreeNode, {
					state: props.state,
					"onUpdate:state": _cache[0] || (_cache[0] = ($event) => props.state = $event),
					cid: `${props.cid}-${index.toString()}`,
					tree: child,
					"filter-func": props.filterFunc,
					"match-override": match_node.value || props.matchOverride
				}, {
					body: withCtx(({ expanded, node, toggle }) => [renderSlot(_ctx.$slots, "body", {
						expanded,
						node,
						toggle
					})]),
					_: 3
				}, 8, [
					"state",
					"cid",
					"tree",
					"filter-func",
					"match-override"
				]);
			}), 256))])) : createCommentVNode("", true)], 2)) : createCommentVNode("", true);
		};
	}
});
//#endregion
//#region src/composables/useSortedArray.ts
/**
* Reactively orders an array by the return value of a value function.
* Automatically recomputes when the array, value function, or reverse flag changes.
*
* @param items - The array to order (plain value, ref, or getter).
* @param orderValueFunc - Function mapping each item to its sort key (plain function or ref holding a function).
* @param reverse - Getter returning true to sort in descending order.
*/
function useSortedArray(items, orderValueFunc, reverse = () => false) {
	return computed(() => {
		const arr = toValue(items) || [];
		const fn = unref(orderValueFunc);
		const rev = reverse();
		const sorted = [...arr].sort((a, b) => {
			const va = fn(a);
			const vb = fn(b);
			if (typeof va === "string" && typeof vb === "string") return va.localeCompare(vb);
			if (va < vb) return -1;
			if (va > vb) return 1;
			return 0;
		});
		return rev ? sorted.reverse() : sorted;
	});
}
//#endregion
//#region src/composables/useSmartFetch.ts
function useSmartFetch(url, options = {}) {
	const data = ref(null);
	const isLoading = ref(false);
	const error = ref(null);
	let controller = new AbortController();
	const maxRetries = options.maxRetries ?? 3;
	const retryDelay_ms = options.retryDelay_ms ?? 500;
	const retryOnStatus = options.retryOnStatus ?? [];
	const waitForRetry = (attempt, signal) => new Promise((resolve, reject) => {
		if (signal.aborted) {
			reject(Object.assign(/* @__PURE__ */ new Error("AbortError"), { name: "AbortError" }));
			return;
		}
		const onAbort = () => {
			clearTimeout(retryTimeout);
			reject(Object.assign(/* @__PURE__ */ new Error("AbortError"), { name: "AbortError" }));
		};
		const retryTimeout = setTimeout(() => {
			signal.removeEventListener("abort", onAbort);
			resolve();
		}, retryDelay_ms * Math.pow(2, attempt));
		signal.addEventListener("abort", onAbort, { once: true });
	});
	const attemptFetch = async (attempt) => {
		controller = new AbortController();
		try {
			const response = await fetch(toValue(url), {
				signal: controller.signal,
				headers: options.headers
			});
			if (!response.ok) {
				if (retryOnStatus.includes(response.status) && attempt < maxRetries) {
					console.warn(`useFetch: HTTP ${response.status} on attempt ${attempt + 1}/${maxRetries + 1}. Retrying in ${retryDelay_ms * Math.pow(2, attempt)}ms.`);
					await waitForRetry(attempt, controller.signal);
					return attemptFetch(attempt + 1);
				}
				isLoading.value = false;
				data.value = null;
				error.value = {
					message: `HTTP error ${response.status}: ${response.statusText}`,
					status: response.status
				};
				return;
			}
			const body = await response.text();
			isLoading.value = false;
			error.value = null;
			let parsed = body;
			const contentType = response.headers.get("content-type") || "";
			if (contentType.includes("application/json") || contentType.endsWith("+json")) try {
				parsed = JSON.parse(body);
			} catch (e) {
				error.value = {
					message: "Error parsing JSON response.",
					status: response.status,
					originalError: e
				};
				console.warn("useFetch: Error parsing JSON response. Returning original body.", e);
			}
			if (typeof options.parseCallback == "function") try {
				parsed = options.parseCallback(parsed);
			} catch (e) {
				error.value = {
					message: "Error in response parse callback function.",
					originalError: e
				};
				console.warn("useFetch: Error in parseCallback. Returning unparsed body.", e);
			}
			data.value = parsed;
		} catch (e) {
			if (e.name === "AbortError") return;
			if (attempt < maxRetries) {
				console.warn(`useFetch: Fetch error on attempt ${attempt + 1}/${maxRetries + 1}. Retrying in ${retryDelay_ms * Math.pow(2, attempt)}ms.`, e);
				try {
					await waitForRetry(attempt, controller.signal);
				} catch (retryErr) {
					if (retryErr.name === "AbortError") return;
					throw retryErr;
				}
				return attemptFetch(attempt + 1);
			}
			isLoading.value = false;
			data.value = null;
			error.value = {
				message: "Unspecified error occurred during fetch attempt.",
				originalError: e
			};
			console.error("useFetch: Fetch error occurred.", e);
		}
	};
	const handler = async () => {
		controller.abort();
		if (!toValue(url)) {
			data.value = null;
			isLoading.value = false;
			error.value = { message: "URL is empty or invalid." };
			return;
		}
		isLoading.value = true;
		error.value = null;
		await attemptFetch(0);
	};
	const handler_debounced = debounce(handler, options.debounceTime_ms ?? 100);
	watch(() => toValue(url), handler_debounced, { immediate: !options.lazy });
	onUnmounted(() => {
		controller.abort();
	});
	return {
		data,
		isLoading,
		error,
		refresh: handler_debounced
	};
}
//#endregion
//#region src/composables/useDelayedBoolean.ts
function useDelayedBoolean(watchedValue, delayOnTrue_ms, delayOnFalse_ms) {
	const result = ref(watchedValue.value);
	let timeout = -1;
	watch(watchedValue, (newValue) => {
		if (timeout !== -1) window.clearTimeout(timeout);
		const delay = newValue ? delayOnTrue_ms : delayOnFalse_ms;
		timeout = window.setTimeout(() => {
			result.value = newValue;
			timeout = -1;
		}, delay);
	});
	return result;
}
//#endregion
//#region src/util/ColorRGBA.ts
var ColorRGBA = class ColorRGBA {
	constructor(values = void 0) {
		_defineProperty(this, "values", [
			0,
			0,
			0,
			255
		]);
		if (values instanceof Array) for (let ii = 0; ii < Math.min(values.length, 5); ii++) this.values[ii] = values[ii];
		else if (typeof values == "string") {
			if (values.charAt(0) == "#") values = values.substring(1);
			if (values.length == 3) values = values.charAt(0) + values.charAt(0) + values.charAt(1) + values.charAt(1) + values.charAt(2) + values.charAt(2);
			const r = parseInt(values.substring(0, 2), 16);
			const g = parseInt(values.substring(2, 4), 16);
			const b = parseInt(values.substring(4, 6), 16);
			let a = 255;
			if (values.length == 8) a = parseInt(values.substring(6, 8), 16);
			this.values = [
				r,
				g,
				b,
				a
			];
		}
	}
	get r() {
		return this.values[0];
	}
	get g() {
		return this.values[1];
	}
	get b() {
		return this.values[2];
	}
	get a() {
		return this.values[3];
	}
	set r(newval) {
		this.values[0] = newval;
	}
	set g(newval) {
		this.values[1] = newval;
	}
	set b(newval) {
		this.values[2] = newval;
	}
	set a(newval) {
		this.values[3] = newval;
	}
	add(other) {
		const result = new ColorRGBA();
		for (let ii = 0; ii < 4; ii++) result.values[ii] = this.values[ii] + other.values[ii];
		return result;
	}
	changeBrightnessByPercent(percent) {
		const result = this.copy();
		for (let ii = 0; ii < 4; ii++) result.values[ii] = Math.min(255, result.values[ii] * ((100 + percent) / 100));
		return result;
	}
	copy() {
		return new ColorRGBA(this.values.slice());
	}
	mult(factor) {
		const result = new ColorRGBA();
		for (let ii = 0; ii < 5; ii++) result.values[ii] = this.values[ii] * factor;
		return result;
	}
	round() {
		const result = new ColorRGBA();
		for (let ii = 0; ii < 5; ii++) result.values[ii] = Math.round(this.values[ii]);
		return result;
	}
	sub(other) {
		const result = new ColorRGBA();
		for (let ii = 0; ii < 5; ii++) result.values[ii] = this.values[ii] - other.values[ii];
		return result;
	}
	decimalToHex(rgb) {
		let hex = Number(rgb).toString(16);
		if (hex.length < 2) hex = "0" + hex;
		return hex;
	}
	toHexString(alpha = true) {
		const rounded = this.round();
		let result = "#" + this.decimalToHex(rounded.r) + this.decimalToHex(rounded.g) + this.decimalToHex(rounded.b);
		if (alpha) result += this.decimalToHex(rounded.a);
		return result;
	}
	toRgbaString() {
		return "rgba(" + this.r + "," + this.g + "," + this.b + "," + this.a + ")";
	}
};
//#endregion
//#region src/util/colorUtils.ts
function makeColorRampArray(colorStart, colorEnd, numSteps) {
	const colStart = new ColorRGBA(colorStart);
	const colorDiff = new ColorRGBA(colorEnd).sub(colStart);
	const colors = Array();
	for (let index = 0; index < numSteps; index++) {
		let step = 0;
		if (numSteps > 1) step = index / (numSteps - 1);
		colors.push(colStart.add(colorDiff.mult(step)).round().toHexString());
	}
	return colors;
}
//#endregion
export { AbstractMapModule, Collapsible_default as Collapsible, ColorRGBA, ColumnChart_default as ColumnChart, Combobox_default as Combobox, ContextHelp_default as ContextHelp, ContextMenu_default as ContextMenu, CustomAxis_default as CustomAxis, DashboardPanel_default as DashboardPanel, DatetimeAxis_default as DatetimeAxis, DualView_default as DualView, HeadlessList_default as HeadlessList, HighlightText_default as HighlightText, Legend_default as Legend, List_default as List, LoadingIndicatorOverlay_default as LoadingIndicatorOverlay, MapLibreMap_default as MapLibreMap, MultiChart_default as MultiChart, MultiChartState, NumericalAxis_default as NumericalAxis, PaginationControl_default as PaginationControl, PieChart_default as PieChart, Popup_default as Popup, ProgressBar_default as ProgressBar, PropertyGrid_default as PropertyGrid, ScrollSensor_default as ScrollSensor, ScrollSensorItem_default as ScrollSensorItem, ScrollSensorMenu_default as ScrollSensorMenu, SelectMode, SmartButton_default as SmartButton, SmartRangeInput_default as SmartRangeInput, SmartSelect_default as SmartSelect, SmartTable_default as SmartTable, SmartTextInput_default as SmartTextInput, Spinner_default as Spinner, SplitPanel_default as SplitPanel, SvgColorGradient_default as SvgColorGradient, Tab_default as Tab, TabsGroup_default as TabsGroup, Tooltip_default as Tooltip, TreeNode_default as TreeNode, ViewStack_default as ViewStack, ViewStackController, buildStackData, clearHelpTexts, contextHelp, contextMenu, debounce, formatNumber, getHelpText, hasHelpText, makeArray, makeColorRampArray, registerHelpText, removeHelpText, roundToDigits, useDelayedBoolean, useDragPosition, useOnElementResize, useOnOutsideClick, useSmartFetch, useSortedArray, useViewportSize };

//# sourceMappingURL=gertrud.js.map